import React, { Fragment, useEffect, useRef, useState } from "react";
import {
    Card,
    CardContent,
    AppBar,
    Grid,
    TextField,
    Box,
    Paper,
    Tab,
    Tabs,
    Typography,
    makeStyles,
    Table,
    TableBody,
    TableCell,
    TableContainer,
    TableHead,
    TableRow,
    withStyles,
    Button,
} from "@material-ui/core";
import PropTypes from "prop-types";
import HttpService from "../../services/httpService";
import { setLoading } from "../../redux/actions/appAction";
import { connect, useSelector } from "react-redux";
import { Modal } from "antd";
import moment from "moment";
import { CSVLink } from "react-csv";
import MenuItem from '@material-ui/core/MenuItem/MenuItem';
import CircularProgress from "@material-ui/core/CircularProgress";
import LocalShippingIcon from "@material-ui/icons/LocalShipping";
import AssignmentTurnedInIcon from "@material-ui/icons/AssignmentTurnedIn";
import BuildCircleIcon from "@material-ui/icons/Build";
import AutorenewIcon from "@material-ui/icons/Autorenew";
import RefreshIcon from "@material-ui/icons/Refresh";
import {
    CONST_USER_ID,
    PalaPrasanthKumarId,
    PalisettiTejaId,
    ROLENAME,
    SriKrishnaId,
    ThirumaleshId,
} from "../../utils";
import { Link } from 'react-router-dom'
import { DownloadOutlined } from '@ant-design/icons';
import { useDispatch } from "react-redux";
import { setSODData } from "../../redux/actions/leadSourceActions";
import { setSOCData } from "../../redux/actions/leadSourceActions";
import { setPPSData } from "../../redux/actions/leadSourceActions";
import { setUESData } from "../../redux/actions/leadSourceActions";


function TabPanel(props) {
    const { children, value, index, ...other } = props;

    return (
        <div
            role="tabpanel"
            hidden={value !== index}
            id={`simple-tabpanel-${index}`}
            aria-labelledby={`simple-tab-${index}`}
            {...other}
        >
            {value === index && (
                <Box p={3}>
                    <Typography>{children}</Typography>
                </Box>
            )}
        </div>
    );
}

TabPanel.propTypes = {
    children: PropTypes.node,
    index: PropTypes.any.isRequired,
    value: PropTypes.any.isRequired,
};

function a11yProps(index) {
    return {
        id: `simple-tab-${index}`,
        "aria-controls": `simple-tabpanel-${index}`,
    };
}

const useStyles = makeStyles((theme) => ({
    root: {
        "& > *": {
            margin: theme.spacing(1),
        },
    },
    // table: {
    // 	maxWidth:"67vw",
    // },
    tablecontainer: {
        display: "flex",
        margin: "25px",
    },
    customTableContainer: {
        overflowX: "initial",
    },
    tableform: {
        display: "flex",
        maxWidth: "100%",
        textAlign: "center"
    },
    paper: {
        padding: theme.spacing(2),
        margin: "auto",
        maxWidth: 400,
    },
    clickableTableCell: {
        cursor: "pointer",
        textDecoration: "underline",
        color: "blue",
    },
    normalTableCell: {
        color: "black",
        "&:hover": {
            cursor: "pointer",
            color: "blue", // you can change the color when hovering here
            textDecoration: "underline",
        },
    },
    tableCell: {
        color: "blue",
        cursor: "pointer",
        textDecoration: "underline",

        // Changing color, cursor and textDecoration on hovering
        // "&:hover": {
        // 	cursor: "pointer",
        // 	color: "blue", // you can change the color when hovering here
        // 	textDecoration: "underline",
        // },
    },
    csv: {
        display: "flex",
        alignItems: "center",
        marginBottom: 20,
    },
    narrowTab: {
        minWidth: "fit-content", // Adjust the width as needed
        // width:"fit-content",
        width: 65,
    },
    margin: {
        margin: theme.spacing(1),
    },
    activeButton: {
        backgroundColor: "#F50057 !important",
        color: "white !important",
        transition: "background-color 0.3s, color 0.3s",
    },
    leadSearchButton: {
        backgroundColor: '#FDB913',
        color: '#151921',
        padding: '1',
        marginRight: '0.5em',
        borderRadius: '20px',
        width: '20%',
        "&:hover": { backgroundColor: "#14419c", color: 'white' }
    },
    leadClearButton: {
        backgroundColor: '#f7b7b7', // light red background
        color: '#151921',
        padding: '1',
        marginRight: '0.5em',
        borderRadius: '20px',
        width: '20%',
    },
    submitButton: {
        backgroundColor: '#F47E46 !important',  // Decorpot Orange
        color: 'white',            // White text
        '&:hover': {
            backgroundColor: '#E0663D !important', // Darker Orange on hover
        },
    },
    headerCell: {
        background: "#1e3a8a",
        color: "#fff",
        fontWeight: 600,
        textAlign: "center",
        position: "sticky",
        top: 0,
        zIndex: 2
    },
    cell: {
        textAlign: "center",
        fontWeight: 600,
        background: "#1e3a8a",
        color: "#fff",
    },
    row: {
        "&:nth-of-type(odd)": {
            backgroundColor: "#fafafa"
        },
        "&:hover": {
            backgroundColor: "#eef2ff"
        }
    },
}));

const StyledTableCell = withStyles((theme) => ({
    head: {
        backgroundColor: "#1C375D",
        color: '#FFF2EB',
        fontWeight: "500",
        width: "102%"
    },
    body: {
        fontSize: 14,
    },
}))(TableCell);

const StyledTableRow = withStyles((theme) => ({
    root: {
        "&:nth-of-type(odd)": {
            backgroundColor: theme.palette.action.hover,
        },
    },
}))(TableRow);

const StageValue = (props) => {
    const classes = useStyles();
    const dispatch = useDispatch();
    const sodData = useSelector((state) => state.leadSource.sodData);
    const socData = useSelector((state) => state.leadSource.socData);
    const ppsData = useSelector((state) => state.leadSource.ppsData);
    const uesData = useSelector((state) => state.leadSource.uesData);
    const [value, setValue] = useState("");
    const { userDetails } = useSelector((state) => state.user);
    const [materialDeliveryData, setMaterialDeliveryData] = useState([]);
    const [underExecutionData, setUnderExecutionData] = useState([]);
    const [projectCompetionData, setProjectCompletionData] = useState([]);
    const [completedMwpData, setCompletedMwpData] = useState([]);
    const [factoryStageData, setFactoryStageData] = useState([]);
    const [factoryDataForOps1, setFactoryDataForOps1] = useState([]);
    const [completedProjectData, setCompletedProjectData] = useState([]);
    const [showDetailedModal, setShowDetailedModal] = useState(false);
    const [detailDataArray, setDetailDataArray] = useState([]);
    const [title, setTitle] = useState("Dummy Title");
    const [csvData, setCsvData] = useState([]);
    const [tableCsvData, setTableCsvData] = useState([]);
    const [summaryOfDeliveryTableCsvData, setSummaryOfDeliveryTableCsvData] = useState([]);
    const summaryOfDeliveryTableCsvButtonRef = useRef(null);
    const [triggerDeliveryDownload, setTriggerDeliveryDownload] = useState(false);
    const [summaryOfCompletionTableCsvData, setSummaryOfCompletionTableCsvData] = useState([]);
    const summaryOfCompletionTableCsvButtonRef = useRef(null);
    const [triggerCompletionDownload, setTriggerCompletionDownload] = useState(false);
    const [preProductionTableCsvData, setPreProductionTableCsvData] = useState([]);
    const preProductionTableCsvButtonRef = useRef(null);
    const [triggerPreProductionDownload, setTriggerPreProductionDownload] = useState(false);
    const [underExecutionTableCsvData, setUnderExecutionTableCsvData] = useState([]);
    const underExecutionTableCsvButtonRef = useRef(null);
    const [triggerUnderExecutionDownload, setTriggerUnderExecutionDownload] = useState(false);
    const [startDate, setStartDate] = useState("");
    const [endDate, setEndDate] = useState("");
    const csvButtonRef = useRef(null);
    const tableCsvButtonRef = useRef(null);
    const [materialDeliveryPercentages, setMaterialDeliveryPercentages] = useState([]);
    const [projectCompletionPercentages, setProjectCompletionPercentages] = useState([]);
    const [factoryDataForOps1Percentages, setFactoryDataForOps1Percentages] = useState([]);
    const [underExecutionPercentages, setUnderExecutionPercentages] = useState([]);
    const [ShowDesignSignOffRevokeDate, setShowDesignSignOffRevokeDate] = useState(false)
    const [searchInput, setSearchInput] = useState("")
    const [selectedSearchType, setSelectedSearchType] = useState("");
    const searchTypes = ['Customer Name', 'Email ID', 'Lead No', 'Project No', 'Contact No', 'Unique Lead No']

    const [loadingSOD, setLoadingSOD] = useState(false);
    const [loadingSOC, setLoadingSOC] = useState(false);
    const [loadingPPS, setLoadingPPS] = useState(false);
    const [loadingUES, setLoadingUES] = useState(false);

    const [lastUsedParamsSOD, setLastUsedParamsSOD] = useState(null);
    const [isInitialRenderSOD, setIsInitialRenderSOD] = useState(true);
    const SOD_BUTTON_DISABLE_UNTIL_KEY = 'sodButton_disableUntil';
    const [isDisabledSOD, setIsDisabledSOD] = useState(false);
    const [timeLeftSOD, setTimeLeftSOD] = useState(0);
    const [isSpinningSOD, setIsSpinningSOD] = useState(false);

    const [lastUsedParamsSOC, setLastUsedParamsSOC] = useState(null);
    const [isInitialRenderSOC, setIsInitialRenderSOC] = useState(true);
    const SOC_BUTTON_DISABLE_UNTIL_KEY = 'socButton_disableUntil';
    const [isDisabledSOC, setIsDisabledSOC] = useState(false);
    const [timeLeftSOC, setTimeLeftSOC] = useState(0);
    const [isSpinningSOC, setIsSpinningSOC] = useState(false);

    const [lastUsedParamsPPS, setLastUsedParamsPPS] = useState(null);
    const [isInitialRenderPPS, setIsInitialRenderPPS] = useState(true);
    const PPS_BUTTON_DISABLE_UNTIL_KEY = 'ppsButton_disableUntil';
    const [isDisabledPPS, setIsDisabledPPS] = useState(false);
    const [timeLeftPPS, setTimeLeftPPS] = useState(0);
    const [isSpinningPPS, setIsSpinningPPS] = useState(false);

    const [lastUsedParamsUES, setLastUsedParamsUES] = useState(null);
    const [isInitialRenderUES, setIsInitialRenderUES] = useState(true);
    const UES_BUTTON_DISABLE_UNTIL_KEY = 'uesButton_disableUntil';
    const [isDisabledUES, setIsDisabledUES] = useState(false);
    const [timeLeftUES, setTimeLeftUES] = useState(0);
    const [isSpinningUES, setIsSpinningUES] = useState(false);


    let includeExperienceCenter = detailDataArray.some(item => item.experienceCenterName !== "" && item.experienceCenterName !== null && item.experienceCenterName !== undefined);
    let includeFactoryBomCompletedDate = detailDataArray.some(item => item.factoryBomCompletedDate !== "" && item.factoryBomCompletedDate !== null && item.factoryBomCompletedDate !== undefined);
    let includeRevocationDate = detailDataArray.some(item => item.designSignoffRevokeDate !== "" && item.designSignoffRevokeDate !== null && item.designSignoffRevokeDate !== undefined);
    let includedesignerAndAdmName = detailDataArray.some(item => item.designManagerName !== "" && item.designManagerName !== null && item.designManagerName !== undefined);
    let includeChmName = detailDataArray.some(item => item.chmUserName !== "" && item.chmUserName !== null && item.chmUserName !== undefined);
    let includeCustomerName = detailDataArray.some(item => item.customerName !== "" && item.customerName !== null && item.customerName !== undefined);
    let includeCustomerAddress = detailDataArray.some(item => item.customerAddress !== "" && item.customerAddress !== null && item.customerAddress !== undefined);
    let includeContractQualityControlApproved = detailDataArray.some(item => item.contractQualityControlApproved !== "" && item.contractQualityControlApproved !== null && item.contractQualityControlApproved !== undefined);
    let includeContractQCManagerApproved = detailDataArray.some(item => item.contractQCManagerApproved !== "" && item.contractQCManagerApproved !== null && item.contractQCManagerApproved !== undefined);
    let includeContractDesignManagerApproved = detailDataArray.some(item => item.contractDesignManagerApproved !== "" && item.contractDesignManagerApproved !== null && item.contractDesignManagerApproved !== undefined);
    let includeContractCustomerApproved = detailDataArray.some(item => item.contractCustomerApproved !== "" && item.contractCustomerApproved !== null && item.contractCustomerApproved !== undefined);
    let includeContractFinanceApproved = detailDataArray.some(item => item.contractFinanceApproved !== "" && item.contractFinanceApproved !== null && item.contractFinanceApproved !== undefined);
    let includeMaterialDeliveryDate = detailDataArray.some(item => item.materialDispatchedDate !== "" && item.materialDispatchedDate !== null && item.materialDispatchedDate !== undefined);
    let includeActualCompletionDate = detailDataArray.some(item => item.executionCompletionDate !== "" && item.executionCompletionDate !== null && item.executionCompletionDate !== undefined);
    let includeExecutionMWPDate = detailDataArray.some(item => item.executionMWPDate !== "" && item.executionMWPDate !== null && item.executionMWPDate !== undefined);

    // Headers for csv file
    const headers = [
        { key: "serialNo", label: "Sl. No." },
        { key: "projectCode", label: "Project No." },
        { key: "leadNo", label: "Lead No" },
        { key: "currentStage", label: "Stage" },
        { key: "departmentName", label: "Department" },
        { key: "totalValue", label: "Value (INR)" },
        { key: "cityName", label: "City Name" },
        { key: "salesWonDate", label: "Sales Won Date" },
        { key: "designSignOffDate", label: "Design Sign-Off Date" },
    ];

    if (includeExperienceCenter) {
        headers.push({ key: "experienceCenter", label: "Experience Center" });
    }
    if (includeFactoryBomCompletedDate) {
        headers.push({ key: "factoryBomCompletedDate", label: "Factory Assignment Date" });
    }
    if (includeRevocationDate) {
        headers.push({ key: "revocationDate", label: "Design-Hold Revoke Date" });
    }
    if (includedesignerAndAdmName) {
        headers.push({ key: "designerAndAdmName", label: "Designer/ADM name" });
    }
    if (includeChmName) {
        headers.push({ key: "chmName", label: "CHM Name" });
    }
    if (includeCustomerName) {
        headers.push({ key: "customerName", label: "Customer name" });
    }
    if (includeContractQualityControlApproved) {
        headers.push({ key: "contractQualityControlApproved", label: "QC Approval" });
    }
    if (includeContractQCManagerApproved) {
        headers.push({ key: "contractQCManagerApproved", label: "QC Manager Approval" });
    }
    if (includeContractDesignManagerApproved) {
        headers.push({ key: "contractDesignManagerApproved", label: "ADM Approval" });
    }
    if (includeContractCustomerApproved) {
        headers.push({ key: "contractCustomerApproved", label: "Customer Approval" });
    }
    if (includeContractFinanceApproved) {
        headers.push({ key: "contractFinanceApproved", label: "Finance Approval" });
    }
    if (includeMaterialDeliveryDate) {
        headers.push({ key: "materialDeliveryDate", label: "Material Delivery Date" });
    }
    if (includeActualCompletionDate) {
        headers.push({ key: "actualCompletionDate", label: "Actual Completion Date" });
    }
    if (includeExecutionMWPDate) {
        headers.push({ key: "executionMWPDate", label: "MWP Completion Date" });
    }
    if (includeCustomerAddress) {
        headers.push({ key: "apartmentName", label: "Apartment Name" });
    }

    const tableHeaders = [
        { key: "serialNo", label: "Sl. No." },
        { key: "projectCode", label: "Project No." },
        { key: "leadNo", label: "Lead No." },
        { key: "stage", label: "Stage" },
        { key: "department", label: "Department" },
        { key: "valueInr", label: "Value (INR)" },
        { key: "city", label: "City" },
        { key: "salesWonDate", label: "Sales Won Date" },
        { key: "designSignOffDate", label: "Design Sign-Off Date" },
        { key: "designerAndAdmName", label: "Designer/ADM name" },
        { key: "apartmentName", label: "Apartment Name" },
        { key: "currentStage", label: "Current stage" },
    ];

    if (value !== "Ops-1" && value !== "Ops-2 (Factory)") {
        tableHeaders.push({ key: "materialDispatchedDate", label: "Material Dispatched Date" });
    }

    if (value !== "Ops-1" && value !== "Ops-2 (Factory)" && value !== "Ops-3 (Execution)") {
        tableHeaders.push({ key: "executionCompletionDate", label: "Execution Completion Date" });
    }

    if (ShowDesignSignOffRevokeDate) {
        tableHeaders.push({ key: "uniqueLeadNumber", label: "Unique Lead ID" });
        tableHeaders.push({ key: "designSignoffRevokeDate", label: "Design Sign-off HOLD Revoke Date" });
    }

    if (value === "Ops-1") {
        tableHeaders.push({ key: "customerName", label: "Customer name" });
        tableHeaders.push({ key: "chmName", label: "CHM Name" });
    }

    if (value === "Summary of Completion") {
        tableHeaders.push({ key: "executionMWPDate", label: "Execution MWP Date" });
    }

    const formatToLakhs = (value) => {
        const valueInLakhs = value / 100000;
        return valueInLakhs.toLocaleString("en-IN", {
            maximumFractionDigits: 2,
            minimumFractionDigits: 2
        });
    };
    // Function to handle tab changes
    const handleChange = (newValue) => {
        setValue(newValue);
        setStartDate("");
        setEndDate("");
        setSearchInput("")
        setSelectedSearchType("")
    };

    const handleSearchType = (value) => {
        setSelectedSearchType(value)
        setSearchInput('')
    }

    const handleSearch = async (diffValue) => {
        getMaterialDeliveryDataCityWise(startDate, endDate, selectedSearchType, searchInput);
        getProjectCompletionDataCityWise(startDate, endDate, selectedSearchType, searchInput);
        getFactoryManagerDataForOps1Tab(selectedSearchType, searchInput);
        getUnderExecutionDataCityWise(startDate, endDate, selectedSearchType, searchInput);
    }

    const isEqual = (obj1, obj2) => {
        // First check if both objects have the same keys
        const keys1 = Object.keys(obj1);
        const keys2 = Object.keys(obj2);

        if (keys1.length !== keys2.length) {
            return false;
        }

        // Check if all keys in obj2 exist in obj1
        for (const key of keys2) {
            if (!keys1.includes(key)) {
                return false;
            }
        }

        // Then compare each key's value
        for (const key in obj1) {
            if (Array.isArray(obj1[key])) {
                // For arrays, check if they have the same length and same items
                if (!Array.isArray(obj2[key]) || obj1[key].length !== obj2[key].length) {
                    return false;
                }

                // For arrays of objects with _id, compare by _id
                if (obj1[key].length > 0 && obj1[key][0]?._id) {
                    const obj1Ids = new Set(obj1[key].map(item => item._id));
                    const obj2Ids = new Set(obj2[key].map(item => item._id));

                    // Check if sets are equal
                    if (obj1Ids.size !== obj2Ids.size) {
                        return false;
                    }

                    for (const id of obj1Ids) {
                        if (!obj2Ids.has(id)) {
                            return false;
                        }
                    }
                } else {
                    // Simple comparison for primitive arrays
                    for (let i = 0; i < obj1[key].length; i++) {
                        if (obj1[key][i] !== obj2[key][i]) {
                            return false;
                        }
                    }
                }
            } else if (obj1[key] !== obj2[key]) {
                return false;
            }
        }

        return true;
    };


    // Function to get Project's count for ops-1 tab
    const getFactoryManagerDataForOps1Tab = async (selectedSearchType, searchInput) => {
        let currentObj = {
            searchType: selectedSearchType ? selectedSearchType : "",
            search: searchInput ? searchInput.toUpperCase() : ""
        }
        // try {
        //     const response = await HttpService.getDataForOps1Tab(obj);
        //     setFactoryDataForOps1(response.data);
        // } catch (error) {
        //     console.log("Error Here ->", error);
        // }
        let shouldMakeApiCall = false;

        // Case 1: No ppsData - must call API
        if (!ppsData || ppsData === null) {
            shouldMakeApiCall = true;
        }
        // Case 2: Not initial render AND parameters changed
        else if (!isInitialRenderPPS && lastUsedParamsPPS && !isEqual(lastUsedParamsPPS, currentObj)) {
            shouldMakeApiCall = true;
        }

        setLoadingPPS(true);
        try {
            if (shouldMakeApiCall) {
                // Call API with current parameters
                let response = await HttpService.getDataForOps1Tab(currentObj);
                setFactoryDataForOps1(response.data);
                dispatch(setPPSData(response.data));
            } else {
                // Use existing data
                setFactoryDataForOps1(ppsData);
            }

            // Always save the current parameters
            setLastUsedParamsPPS({ ...currentObj });

            // No longer initial render after first execution
            if (isInitialRenderPPS) {
                setIsInitialRenderPPS(false);
            }
        } catch (error) {
            props.setSnackInfo(error?.response?.data ?? "Something Went Wrong", "error");
        }
        setLoadingPPS(false);
    };


    // Add this effect to initialize state from localStorage and handle timer
    useEffect(() => {
        // Check if there's a stored disable time in localStorage
        const disableUntilTimestamp = localStorage.getItem(PPS_BUTTON_DISABLE_UNTIL_KEY);

        if (disableUntilTimestamp) {
            const now = new Date().getTime();
            const disableUntil = parseInt(disableUntilTimestamp, 10);

            // If the disable time is in the future, calculate remaining time
            if (disableUntil > now) {
                const remainingTimeInSeconds = Math.ceil((disableUntil - now) / 1000);
                setTimeLeftPPS(remainingTimeInSeconds);
                setIsDisabledPPS(true);
            } else {
                // If the time has passed, clear localStorage
                localStorage.removeItem(PPS_BUTTON_DISABLE_UNTIL_KEY);
                setIsDisabledPPS(false);
                setTimeLeftPPS(0);
            }
        }

        // Set up timer to update remaining time
        let timer;
        if (isDisabledPPS && timeLeftPPS > 0) {
            timer = setInterval(() => {
                setTimeLeftPPS(prevTime => {
                    const newTime = prevTime - 1;
                    if (newTime <= 0) {
                        // When time is up, clear localStorage and enable button
                        localStorage.removeItem(PPS_BUTTON_DISABLE_UNTIL_KEY);
                        setIsDisabledPPS(false);
                        return 0;
                    }
                    return newTime;
                });
            }, 1000);
        }

        return () => clearInterval(timer);
    }, [isDisabledPPS, timeLeftPPS]);

    // Format time for display
    const formatTimeLeftPPS = () => {
        const minutes = Math.floor(timeLeftPPS / 60);
        const seconds = timeLeftPPS % 60;
        return `${minutes}:${seconds < 10 ? '0' : ''}${seconds}`;
    };

    const handleRefreshClickPPS = () => {
        // Calculate the timestamp 4 minutes from now
        const disableUntilTimestamp = new Date().getTime() + (4 * 60 * 1000);

        // Store the timestamp in localStorage
        localStorage.setItem(PPS_BUTTON_DISABLE_UNTIL_KEY, disableUntilTimestamp.toString());

        // Disable the button for 4 minutes
        setIsDisabledPPS(true);
        setTimeLeftPPS(240); // 4 minutes in seconds

        // Run the original functionality
        setIsSpinningPPS(true);
        getRefreshedDataPPS(startDate, endDate, selectedSearchType, searchInput);
        setTimeout(() => {
            setIsSpinningPPS(false);
        }, 1000);
    };

    const getRefreshedDataPPS = async (selectedSearchType, searchInput) => {
        setLoadingPPS(true);
        let obj = {
            searchType: selectedSearchType ? selectedSearchType : "",
            search: searchInput ? searchInput.toUpperCase() : ""
        }
        try {
            const response = await HttpService.getDataForOps1Tab(obj);
            setFactoryDataForOps1(response.data);
            dispatch(setPPSData(response.data));
        } catch (error) {
            console.log("Error Here ->", error);
        }
        setLoadingPPS(false);
    };

    const getMaterialDeliveryDataCityWise = async (startDate, endDate, selectedSearchType, searchInput) => {
        let currentObj = {
            startDate: startDate,
            endDate: endDate,
            searchType: selectedSearchType ? selectedSearchType : "",
            search: searchInput ? searchInput.toUpperCase() : ""
        }
        // try {
        //     const response = await HttpService.getMaterialDeliveryCityWise(currentObj);
        //     setMaterialDeliveryData(response.data);
        // } catch (error) {
        //     console.log("getMaterialDeliveryDataCityWise Error ->", error);
        // }
        let shouldMakeApiCall = false;

        // Case 1: No sodData - must call API
        if (!sodData || sodData === null) {
            shouldMakeApiCall = true;
        }
        // Case 2: Not initial render AND parameters changed
        else if (!isInitialRenderSOD && lastUsedParamsSOD && !isEqual(lastUsedParamsSOD, currentObj)) {
            shouldMakeApiCall = true;
        }

        setLoadingSOD(true);
        try {
            if (shouldMakeApiCall) {
                // Call API with current parameters
                let response = await HttpService.getMaterialDeliveryCityWise(currentObj);
                setMaterialDeliveryData(response.data);
                dispatch(setSODData(response.data));
            } else {
                // Use existing data
                setMaterialDeliveryData(sodData);
            }

            // Always save the current parameters
            setLastUsedParamsSOD({ ...currentObj });

            // No longer initial render after first execution
            if (isInitialRenderSOD) {
                setIsInitialRenderSOD(false);
            }
        } catch (error) {
            console.error("getMaterialDeliveryDataCityWise Error ->", error);
            props.setSnackInfo("Something Went Wrong", "error");
        }
        setLoadingSOD(false);
    };

    // Add this effect to initialize state from localStorage and handle timer
    useEffect(() => {
        // Check if there's a stored disable time in localStorage
        const disableUntilTimestamp = localStorage.getItem(SOD_BUTTON_DISABLE_UNTIL_KEY);

        if (disableUntilTimestamp) {
            const now = new Date().getTime();
            const disableUntil = parseInt(disableUntilTimestamp, 10);

            // If the disable time is in the future, calculate remaining time
            if (disableUntil > now) {
                const remainingTimeInSeconds = Math.ceil((disableUntil - now) / 1000);
                setTimeLeftSOD(remainingTimeInSeconds);
                setIsDisabledSOD(true);
            } else {
                // If the time has passed, clear localStorage
                localStorage.removeItem(SOD_BUTTON_DISABLE_UNTIL_KEY);
                setIsDisabledSOD(false);
                setTimeLeftSOD(0);
            }
        }

        // Set up timer to update remaining time
        let timer;
        if (isDisabledSOD && timeLeftSOD > 0) {
            timer = setInterval(() => {
                setTimeLeftSOD(prevTime => {
                    const newTime = prevTime - 1;
                    if (newTime <= 0) {
                        // When time is up, clear localStorage and enable button
                        localStorage.removeItem(SOD_BUTTON_DISABLE_UNTIL_KEY);
                        setIsDisabledSOD(false);
                        return 0;
                    }
                    return newTime;
                });
            }, 1000);
        }

        return () => clearInterval(timer);
    }, [isDisabledSOD, timeLeftSOD]);

    // Format time for display
    const formatTimeLeftSOD = () => {
        const minutes = Math.floor(timeLeftSOD / 60);
        const seconds = timeLeftSOD % 60;
        return `${minutes}:${seconds < 10 ? '0' : ''}${seconds}`;
    };

    const handleRefreshClickSOD = () => {
        // Calculate the timestamp 4 minutes from now
        const disableUntilTimestamp = new Date().getTime() + (4 * 60 * 1000);

        // Store the timestamp in localStorage
        localStorage.setItem(SOD_BUTTON_DISABLE_UNTIL_KEY, disableUntilTimestamp.toString());

        // Disable the button for 4 minutes
        setIsDisabledSOD(true);
        setTimeLeftSOD(240); // 4 minutes in seconds

        // Run the original functionality
        setIsSpinningSOD(true);
        getRefreshedDataSOD(startDate, endDate, selectedSearchType, searchInput);
        setTimeout(() => {
            setIsSpinningSOD(false);
        }, 1000);
    };


    const getRefreshedDataSOD = async (startDate, endDate, selectedSearchType, searchInput) => {
        setLoadingSOD(true);
        let obj = {
            startDate: startDate,
            endDate: endDate,
            searchType: selectedSearchType ? selectedSearchType : "",
            search: searchInput ? searchInput.toUpperCase() : ""
        }
        try {
            const response = await HttpService.getMaterialDeliveryCityWise(obj);
            setMaterialDeliveryData(response.data);
            dispatch(setSODData(response.data));
        } catch (error) {
            console.log("Error ->", error);
        }
        setLoadingSOD(false);
    };

    const getProjectCompletionDataCityWise = async (startDate, endDate, selectedSearchType, searchInput) => {
        let currentObj = {
            startDate: startDate,
            endDate: endDate,
            searchType: selectedSearchType ? selectedSearchType : "",
            search: searchInput ? searchInput.toUpperCase() : ""
        }
        // try {
        //     const response = await HttpService.getProjectCompletionDataCityWise(currentObj);
        //     setProjectCompletionData(response.data);
        // } catch (error) {
        //     console.log("Error ->", error);
        // }
        let shouldMakeApiCall = false;

        // Case 1: No socData - must call API
        if (!socData || socData === null) {
            shouldMakeApiCall = true;
        }
        // Case 2: Not initial render AND parameters changed
        else if (!isInitialRenderSOC && lastUsedParamsSOC && !isEqual(lastUsedParamsSOC, currentObj)) {
            shouldMakeApiCall = true;
        }

        setLoadingSOC(true);
        try {
            if (shouldMakeApiCall) {
                // Call API with current parameters
                let response = await HttpService.getProjectCompletionDataCityWise(currentObj);
                setProjectCompletionData(response.data);
                dispatch(setSOCData(response.data));
            } else {
                // Use existing data
                setProjectCompletionData(socData);
            }

            // Always save the current parameters
            setLastUsedParamsSOC({ ...currentObj });

            // No longer initial render after first execution
            if (isInitialRenderSOC) {
                setIsInitialRenderSOC(false);
            }
        } catch (error) {
            console.error("getProjectCompletionDataCityWise Error ->", error);
            props.setSnackInfo("Something Went Wrong", "error");
        }
        setLoadingSOC(false);
    };

    // Add this effect to initialize state from localStorage and handle timer
    useEffect(() => {
        // Check if there's a stored disable time in localStorage
        const disableUntilTimestamp = localStorage.getItem(SOC_BUTTON_DISABLE_UNTIL_KEY);

        if (disableUntilTimestamp) {
            const now = new Date().getTime();
            const disableUntil = parseInt(disableUntilTimestamp, 10);

            // If the disable time is in the future, calculate remaining time
            if (disableUntil > now) {
                const remainingTimeInSeconds = Math.ceil((disableUntil - now) / 1000);
                setTimeLeftSOC(remainingTimeInSeconds);
                setIsDisabledSOC(true);
            } else {
                // If the time has passed, clear localStorage
                localStorage.removeItem(SOC_BUTTON_DISABLE_UNTIL_KEY);
                setIsDisabledSOC(false);
                setTimeLeftSOC(0);
            }
        }

        // Set up timer to update remaining time
        let timer;
        if (isDisabledSOC && timeLeftSOC > 0) {
            timer = setInterval(() => {
                setTimeLeftSOC(prevTime => {
                    const newTime = prevTime - 1;
                    if (newTime <= 0) {
                        // When time is up, clear localStorage and enable button
                        localStorage.removeItem(SOC_BUTTON_DISABLE_UNTIL_KEY);
                        setIsDisabledSOC(false);
                        return 0;
                    }
                    return newTime;
                });
            }, 1000);
        }

        return () => clearInterval(timer);
    }, [isDisabledSOC, timeLeftSOC]);

    // Format time for display
    const formatTimeLeftSOC = () => {
        const minutes = Math.floor(timeLeftSOC / 60);
        const seconds = timeLeftSOC % 60;
        return `${minutes}:${seconds < 10 ? '0' : ''}${seconds}`;
    };

    const handleRefreshClickSOC = () => {
        // Calculate the timestamp 4 minutes from now
        const disableUntilTimestamp = new Date().getTime() + (4 * 60 * 1000);

        // Store the timestamp in localStorage
        localStorage.setItem(SOC_BUTTON_DISABLE_UNTIL_KEY, disableUntilTimestamp.toString());

        // Disable the button for 4 minutes
        setIsDisabledSOC(true);
        setTimeLeftSOC(240); // 4 minutes in seconds

        // Run the original functionality
        setIsSpinningSOC(true);
        getRefreshedDataSOC(startDate, endDate, selectedSearchType, searchInput);
        setTimeout(() => {
            setIsSpinningSOC(false);
        }, 1000);
    };


    const getRefreshedDataSOC = async (startDate, endDate, selectedSearchType, searchInput) => {
        setLoadingSOC(true);
        let obj = {
            startDate: startDate,
            endDate: endDate,
            searchType: selectedSearchType ? selectedSearchType : "",
            search: searchInput ? searchInput.toUpperCase() : ""
        }
        try {
            const response = await HttpService.getProjectCompletionDataCityWise(obj);
            setProjectCompletionData(response.data);
            dispatch(setSOCData(response.data));
        } catch (error) {
            console.log("Error ->", error);
        }
        setLoadingSOC(false);
    };

    const getUnderExecutionDataCityWise = async (startDate, endDate, selectedSearchType, searchInput) => {
        let currentObj = {
            startDate: startDate,
            endDate: endDate,
            searchType: selectedSearchType ? selectedSearchType : "",
            search: searchInput ? searchInput.toUpperCase() : ""
        }
        // try {
        //     const response = await HttpService.getUnderExecutionDataCityWise(currentObj);
        //     setUnderExecutionData(response.data);
        // } catch (error) {
        //     console.log("Error ->", error);
        // }
        let shouldMakeApiCall = false;

        // Case 1: No uesData - must call API
        if (!uesData || uesData === null) {
            shouldMakeApiCall = true;
        }
        // Case 2: Not initial render AND parameters changed
        else if (!isInitialRenderUES && lastUsedParamsUES && !isEqual(lastUsedParamsUES, currentObj)) {
            shouldMakeApiCall = true;
        }

        setLoadingUES(true);
        try {
            if (shouldMakeApiCall) {
                // Call API with current parameters
                let response = await HttpService.getUnderExecutionDataCityWise(currentObj);
                setUnderExecutionData(response.data);
                dispatch(setUESData(response.data));
            } else {
                // Use existing data
                setUnderExecutionData(uesData);
            }

            // Always save the current parameters
            setLastUsedParamsUES({ ...currentObj });

            // No longer initial render after first execution
            if (isInitialRenderUES) {
                setIsInitialRenderUES(false);
            }
        } catch (error) {
            console.error("getUnderExecutionDataCityWise Error ->", error);
            props.setSnackInfo("Something Went Wrong", "error");
        }
        setLoadingUES(false);
    };

    // Add this effect to initialize state from localStorage and handle timer
    useEffect(() => {
        // Check if there's a stored disable time in localStorage
        const disableUntilTimestamp = localStorage.getItem(UES_BUTTON_DISABLE_UNTIL_KEY);

        if (disableUntilTimestamp) {
            const now = new Date().getTime();
            const disableUntil = parseInt(disableUntilTimestamp, 10);

            // If the disable time is in the future, calculate remaining time
            if (disableUntil > now) {
                const remainingTimeInSeconds = Math.ceil((disableUntil - now) / 1000);
                setTimeLeftUES(remainingTimeInSeconds);
                setIsDisabledUES(true);
            } else {
                // If the time has passed, clear localStorage
                localStorage.removeItem(UES_BUTTON_DISABLE_UNTIL_KEY);
                setIsDisabledUES(false);
                setTimeLeftUES(0);
            }
        }

        // Set up timer to update remaining time
        let timer;
        if (isDisabledUES && timeLeftUES > 0) {
            timer = setInterval(() => {
                setTimeLeftUES(prevTime => {
                    const newTime = prevTime - 1;
                    if (newTime <= 0) {
                        // When time is up, clear localStorage and enable button
                        localStorage.removeItem(UES_BUTTON_DISABLE_UNTIL_KEY);
                        setIsDisabledUES(false);
                        return 0;
                    }
                    return newTime;
                });
            }, 1000);
        }

        return () => clearInterval(timer);
    }, [isDisabledUES, timeLeftUES]);

    // Format time for display
    const formatTimeLeftUES = () => {
        const minutes = Math.floor(timeLeftUES / 60);
        const seconds = timeLeftUES % 60;
        return `${minutes}:${seconds < 10 ? '0' : ''}${seconds}`;
    };

    const handleRefreshClickUES = () => {
        // Calculate the timestamp 4 minutes from now
        const disableUntilTimestamp = new Date().getTime() + (4 * 60 * 1000);

        // Store the timestamp in localStorage
        localStorage.setItem(UES_BUTTON_DISABLE_UNTIL_KEY, disableUntilTimestamp.toString());

        // Disable the button for 4 minutes
        setIsDisabledUES(true);
        setTimeLeftUES(240); // 4 minutes in seconds

        // Run the original functionality
        setIsSpinningUES(true);
        getRefreshedDataUES(startDate, endDate, selectedSearchType, searchInput);
        setTimeout(() => {
            setIsSpinningUES(false);
        }, 1000);
    };

    const getRefreshedDataUES = async (startDate, endDate, selectedSearchType, searchInput) => {
        setLoadingUES(true);
        let obj = {
            startDate: startDate,
            endDate: endDate,
            searchType: selectedSearchType ? selectedSearchType : "",
            search: searchInput ? searchInput.toUpperCase() : ""
        }
        try {
            const response = await HttpService.getUnderExecutionDataCityWise(obj);
            setUnderExecutionData(response.data);
            dispatch(setUESData(response.data));
        } catch (error) {
            console.log("Error ->", error);
        }
        setLoadingUES(false);
    };

    // Function to show Details
    const showDetailedModalHandler = (data, text) => {
        try {
            let call = data.map((el) => el.currentStage);
            let checkStage = call.every((el) => el === 'Design Sign-off HOLD');
            setShowDesignSignOffRevokeDate(checkStage)
            setShowDetailedModal(true);
            setTitle(text);
            setDetailDataArray(data);
        } catch (error) {
            console.log("Error - ", error);
        }
    };

    // Function to download csv
    const csvDownloadHandler = async (data) => {
        setLoading(true);
        try {
            let csvArray = [];
            for (let i = 0; i < detailDataArray.length; i++) {
                let obj = {
                    serialNo: i + 1,
                    projectCode: detailDataArray[i]?.erpProjectNo || "N/A",
                    leadNo: detailDataArray[i]?.lead_no,
                    currentStage: detailDataArray[i]?.currentStage,
                    departmentName: detailDataArray[i]?.departmentName,
                    totalValue: detailDataArray[i]?.grandTotal / 1.18 || "-",
                    cityName: detailDataArray[i]?.cityName,
                    salesWonDate: detailDataArray[i]?.leadWonDate
                        ? moment(detailDataArray[i]?.leadWonDate).format("DD-MM-YYYY")
                        : "-",
                    designSignOffDate: detailDataArray[i]?.customerDesignSignOffDate
                        ? moment(detailDataArray[i]?.customerDesignSignOffDate).format(
                            "DD-MM-YYYY"
                        )
                        : "-",
                    materialDeliveryDate: detailDataArray[i]?.materialDispatchedDate
                        ? moment(detailDataArray[i]?.materialDispatchedDate).format(
                            "DD-MM-YYYY"
                        )
                        : "-",
                    actualCompletionDate: detailDataArray[i]?.executionCompletionDate
                        ? moment(detailDataArray[i]?.executionCompletionDate).format(
                            "DD-MM-YYYY"
                        )
                        : "-",
                    executionMWPDate: detailDataArray[i]?.executionMWPDate
                        ? moment(detailDataArray[i]?.executionMWPDate).format(
                            "DD-MM-YYYY"
                        )
                        : "-",
                    designerAndAdmName: detailDataArray[i]?.designUserName + " / " + detailDataArray[i]?.designManagerName,
                    apartmentName: detailDataArray[i]?.customerAddress,
                    customerName: detailDataArray[i]?.customerName,
                    chmName: detailDataArray[i]?.chmUserName,
                    factoryBomCompletedDate: detailDataArray[i]?.factoryBomCompletedDate
                        ? moment(detailDataArray[i]?.factoryBomCompletedDate).format(
                            "DD-MM-YYYY"
                        )
                        : "-",
                    revocationDate: detailDataArray[i]?.designSignoffRevokeDate
                        ? moment(detailDataArray[i]?.designSignoffRevokeDate).format(
                            "DD-MM-YYYY"
                        )
                        : "-",
                    experienceCenter: detailDataArray[i]?.experienceCenterName,
                    contractQualityControlApproved: detailDataArray[i]?.contractQualityControlApproved,
                    contractQCManagerApproved: detailDataArray[i]?.contractQCManagerApproved,
                    contractDesignManagerApproved: detailDataArray[i]?.contractDesignManagerApproved,
                    contractCustomerApproved: detailDataArray[i]?.contractCustomerApproved,
                    contractFinanceApproved: detailDataArray[i]?.contractFinanceApproved,
                };
                csvArray.push(obj);
                obj = {
                    serialNo: "",
                    projectCode: "",
                    leadNo: "",
                    totalValue: "",
                    cityName: "",
                    salesWonDate: "",
                    designSignOffDate: "",
                    materialDeliveryDate: "",
                    actualCompletionDate: "",
                    revocationDate: "",
                    factoryBomCompletedDate: "",
                    experienceCenter: "",
                };
                csvArray.push(obj);
            }
            setCsvData(csvArray);
            downloadExcel();
        } catch (error) {
            console.log("error", error);
            props?.setSnackInfo(
                error?.response?.data?.message ?? "Something went wrong",
                "error"
            );
        }
        setLoading(false);
    };

    const downloadExcel = () => {
        setLoading(true);
        try {
            setTimeout(() => {
                csvButtonRef.current.link.click();
            });
        } catch (err) {
            console.error(err.message);
        }
        setLoading(false);
    };

    // Trigger CSV downloads when data is ready
    useEffect(() => {
        if (triggerDeliveryDownload && summaryOfDeliveryTableCsvData.length > 0) {
            const timer = setTimeout(() => {
                if (summaryOfDeliveryTableCsvButtonRef.current?.link) {
                    try {
                        summaryOfDeliveryTableCsvButtonRef.current.link.click();
                    } catch (error) {
                        console.error("Error triggering CSV download:", error);
                        props?.setSnackInfo("Error downloading CSV", "error");
                    }
                    setTriggerDeliveryDownload(false);
                } else {
                    setTimeout(() => {
                        if (summaryOfDeliveryTableCsvButtonRef.current?.link) {
                            summaryOfDeliveryTableCsvButtonRef.current.link.click();
                            setTriggerDeliveryDownload(false);
                        }
                    }, 200);
                }
            }, 300);
            return () => clearTimeout(timer);
        }
    }, [triggerDeliveryDownload, summaryOfDeliveryTableCsvData]);

    useEffect(() => {
        if (triggerCompletionDownload && summaryOfCompletionTableCsvData.length > 0) {
            const timer = setTimeout(() => {
                if (summaryOfCompletionTableCsvButtonRef.current?.link) {
                    try {
                        summaryOfCompletionTableCsvButtonRef.current.link.click();
                    } catch (error) {
                        console.error("Error triggering CSV download:", error);
                        props?.setSnackInfo("Error downloading CSV", "error");
                    }
                    setTriggerCompletionDownload(false);
                } else {
                    setTimeout(() => {
                        if (summaryOfCompletionTableCsvButtonRef.current?.link) {
                            summaryOfCompletionTableCsvButtonRef.current.link.click();
                            setTriggerCompletionDownload(false);
                        }
                    }, 200);
                }
            }, 300);
            return () => clearTimeout(timer);
        }
    }, [triggerCompletionDownload, summaryOfCompletionTableCsvData]);

    useEffect(() => {
        if (triggerPreProductionDownload && preProductionTableCsvData.length > 0) {
            const timer = setTimeout(() => {
                if (preProductionTableCsvButtonRef.current?.link) {
                    try {
                        preProductionTableCsvButtonRef.current.link.click();
                    } catch (error) {
                        console.error("Error triggering CSV download:", error);
                        props?.setSnackInfo("Error downloading CSV", "error");
                    }
                    setTriggerPreProductionDownload(false);
                } else {
                    setTimeout(() => {
                        if (preProductionTableCsvButtonRef.current?.link) {
                            preProductionTableCsvButtonRef.current.link.click();
                            setTriggerPreProductionDownload(false);
                        }
                    }, 200);
                }
            }, 300);
            return () => clearTimeout(timer);
        }
    }, [triggerPreProductionDownload, preProductionTableCsvData]);

    useEffect(() => {
        if (triggerUnderExecutionDownload && underExecutionTableCsvData.length > 0) {
            const timer = setTimeout(() => {
                if (underExecutionTableCsvButtonRef.current?.link) {
                    try {
                        underExecutionTableCsvButtonRef.current.link.click();
                    } catch (error) {
                        console.error("Error triggering CSV download:", error);
                        props?.setSnackInfo("Error downloading CSV", "error");
                    }
                    setTriggerUnderExecutionDownload(false);
                } else {
                    setTimeout(() => {
                        if (underExecutionTableCsvButtonRef.current?.link) {
                            underExecutionTableCsvButtonRef.current.link.click();
                            setTriggerUnderExecutionDownload(false);
                        }
                    }, 200);
                }
            }, 300);
            return () => clearTimeout(timer);
        }
    }, [triggerUnderExecutionDownload, underExecutionTableCsvData]);

    // Function to format value to lakhs (matching table display)
    const formatToLakhsForCsv = (value) => {
        if (!value || value === 0) return "0.00";
        const valueInLakhs = value / 100000;
        return valueInLakhs.toLocaleString("en-IN", {
            maximumFractionDigits: 2,
            minimumFractionDigits: 2
        });
    };

    // Function to generate CSV data for Summary of Delivery table
    const generateSummaryOfDeliveryTableCsvData = () => {
        try {
            if (!materialDeliveryData || materialDeliveryData.length === 0 || !materialDeliveryData[0]?.monthlyData) {
                return [];
            }

            const csvRows = [];

            // Build header row
            const headerRow = {
                "Modular Delivery Month": ""
            };

            // Add location columns
            materialDeliveryData.forEach((el) => {
                if (el?.locationDetail?.locationName) {
                    const colName = el?.locationDetail?.locationName !== "Grand Total"
                        ? el?.locationDetail?.locationName
                        : "Grand Total (In Lakhs)";
                    headerRow[colName] = "";
                }
            });
            headerRow["Percentage"] = "";
            headerRow["Calculated Value"] = "";
            csvRows.push(headerRow);

            // Add data rows
            materialDeliveryData[0].monthlyData.forEach((monthEl, i) => {
                const row = {
                    "Modular Delivery Month": monthEl?.mmyyyy === "Grand Total"
                        ? monthEl?.mmyyyy
                        : `${monthEl?.mmyyyy.slice(0, 3)}-${monthEl?.mmyyyy.slice(-2)}`
                };

                // Add value for each location
                materialDeliveryData.forEach((data) => {
                    const monthlyData = data?.monthlyData?.find(
                        (md) => md?.mmyyyy === monthEl?.mmyyyy
                    );
                    if (data?.locationDetail?.locationName) {
                        const colName = data?.locationDetail?.locationName !== "Grand Total"
                            ? data?.locationDetail?.locationName
                            : "Grand Total (In Lakhs)";
                        row[colName] = formatToLakhsForCsv((monthlyData?.grandTotal / 1.18) || 0);
                    }
                });

                // Add percentage and calculated value
                row["Percentage"] = materialDeliveryPercentages[i] || "";
                row["Calculated Value"] = calculateValueDelivery(i);

                csvRows.push(row);
            });

            return csvRows;
        } catch (error) {
            console.error("Error generating summary of delivery table CSV:", error);
            return [];
        }
    };

    // Function to generate CSV data for Summary of Completion table
    const generateSummaryOfCompletionTableCsvData = () => {
        try {
            if (!projectCompetionData || projectCompetionData.length === 0 || !projectCompetionData[0]?.monthlyData) {
                return [];
            }

            const csvRows = [];

            // Build header row
            const headerRow = {
                "Project Completion Month": ""
            };

            // Add location columns
            projectCompetionData.forEach((el) => {
                if (el?.locationDetail?.locationName) {
                    const colName = el?.locationDetail?.locationName !== "Grand Total"
                        ? el?.locationDetail?.locationName
                        : "Grand Total (In Lakhs)";
                    headerRow[colName] = "";
                }
            });
            headerRow["Percentage"] = "";
            headerRow["Calculated Value"] = "";
            csvRows.push(headerRow);

            // Add data rows
            projectCompetionData[0].monthlyData.forEach((monthEl, i) => {
                const row = {
                    "Project Completion Month": monthEl?.mmyyyy === "Grand Total"
                        ? monthEl?.mmyyyy
                        : `${monthEl?.mmyyyy.slice(0, 3)}-${monthEl?.mmyyyy.slice(-2)}`
                };

                // Add value for each location
                projectCompetionData.forEach((data) => {
                    const monthlyData = data?.monthlyData?.find(
                        (md) => md?.mmyyyy === monthEl?.mmyyyy
                    );
                    if (data?.locationDetail?.locationName) {
                        const colName = data?.locationDetail?.locationName !== "Grand Total"
                            ? data?.locationDetail?.locationName
                            : "Grand Total (In Lakhs)";
                        row[colName] = formatToLakhsForCsv((monthlyData?.grandTotal / 1.18) || 0);
                    }
                });

                // Add percentage and calculated value
                row["Percentage"] = projectCompletionPercentages[i] || "";
                row["Calculated Value"] = calculateValueCompletion(i);

                csvRows.push(row);
            });

            return csvRows;
        } catch (error) {
            console.error("Error generating summary of completion table CSV:", error);
            return [];
        }
    };

    // Function to generate CSV data for Pre Production Summary table
    const generatePreProductionTableCsvData = () => {
        try {
            if (!factoryDataForOps1 || factoryDataForOps1.length === 0 || !factoryDataForOps1[0]?.stageData) {
                return [];
            }

            const csvRows = [];

            // Build header row
            const headerRow = {
                "Ops-1 Stages": ""
            };

            // Add location columns
            factoryDataForOps1.forEach((el) => {
                if (el?.locationDetail?.locationName) {
                    const colName = el?.locationDetail?.locationName !== "Grand Total"
                        ? el?.locationDetail?.locationName
                        : "Grand Total (In Lakhs)";
                    headerRow[colName] = "";
                }
            });
            headerRow["Percentage"] = "";
            headerRow["Calculated Value"] = "";
            csvRows.push(headerRow);

            // Add data rows
            factoryDataForOps1[0].stageData.forEach((stageEl, i) => {
                const row = {
                    "Ops-1 Stages": stageEl?.stage || ""
                };

                // Add value for each location
                factoryDataForOps1.forEach((data) => {
                    const stageData = data?.stageData?.find(
                        (sd) => sd?.stage === stageEl?.stage
                    );
                    if (data?.locationDetail?.locationName) {
                        const colName = data?.locationDetail?.locationName !== "Grand Total"
                            ? data?.locationDetail?.locationName
                            : "Grand Total (In Lakhs)";
                        row[colName] = formatToLakhsForCsv((stageData?.grandTotal / 1.18) || 0);
                    }
                });

                // Add percentage and calculated value
                row["Percentage"] = factoryDataForOps1Percentages[i] || "";
                row["Calculated Value"] = calculateValueOps(i);

                csvRows.push(row);
            });

            return csvRows;
        } catch (error) {
            console.error("Error generating pre production table CSV:", error);
            return [];
        }
    };

    // Function to generate CSV data for Under Execution Summary table
    const generateUnderExecutionTableCsvData = () => {
        try {
            if (!underExecutionData || underExecutionData.length === 0 || !underExecutionData[0]?.monthlyData) {
                return [];
            }

            const csvRows = [];

            // Build header row
            const headerRow = {
                "Modular Delivery Month": ""
            };

            // Add location columns
            underExecutionData.forEach((el) => {
                if (el?.locationDetail?.locationName) {
                    const colName = el?.locationDetail?.locationName !== "Grand Total"
                        ? el?.locationDetail?.locationName
                        : "Grand Total (In Lakhs)";
                    headerRow[colName] = "";
                }
            });
            headerRow["Percentage"] = "";
            headerRow["Calculated Value"] = "";
            csvRows.push(headerRow);

            // Add data rows
            underExecutionData[0].monthlyData.forEach((monthEl, i) => {
                const row = {
                    "Modular Delivery Month": monthEl?.mmyyyy === "Grand Total"
                        ? monthEl?.mmyyyy
                        : `${monthEl?.mmyyyy.slice(0, 3)}-${monthEl?.mmyyyy.slice(-2)}`
                };

                // Add value for each location
                underExecutionData.forEach((data) => {
                    const monthlyData = data?.monthlyData?.find(
                        (md) => md?.mmyyyy === monthEl?.mmyyyy
                    );
                    if (data?.locationDetail?.locationName) {
                        const colName = data?.locationDetail?.locationName !== "Grand Total"
                            ? data?.locationDetail?.locationName
                            : "Grand Total (In Lakhs)";
                        row[colName] = formatToLakhsForCsv((monthlyData?.grandTotal / 1.18) || 0);
                    }
                });

                // Add percentage and calculated value
                row["Percentage"] = underExecutionPercentages[i] || "";
                row["Calculated Value"] = calculateValueOps3(i);

                csvRows.push(row);
            });

            return csvRows;
        } catch (error) {
            console.error("Error generating under execution table CSV:", error);
            return [];
        }
    };

    const tableCsvDownloadHandler = () => {
        setLoading(true);
        try {
            let csvArray = [];
            for (let i = 0; i < detailDataArray.length; i++) {
                const data = detailDataArray[i];
                let valueInr = "N/A";
                if (data?.grandTotal) {
                    valueInr = (data.grandTotal / 1.18)?.toLocaleString("en-IN", {
                        maximumFractionDigits: 2,
                        minimumFractionDigits: 2
                    });
                }

                let obj = {
                    serialNo: i + 1,
                    projectCode: data?.erpProjectNo || "N/A",
                    leadNo: data?.lead_no || "N/A",
                    stage: data?.currentStage || "N/A",
                    department: data?.departmentName || "N/A",
                    valueInr: valueInr,
                    city: data?.cityName || "N/A",
                    salesWonDate: data?.leadWonDate
                        ? moment(data?.leadWonDate).utc().format("DD-MM-YYYY")
                        : "-",
                    designSignOffDate: data?.customerDesignSignOffDate
                        ? moment(data?.customerDesignSignOffDate).utc().format("DD-MM-YYYY")
                        : "-",
                    designerAndAdmName: (data?.designUserName || "N/A") + " / " + (data?.designManagerName || "N/A"),
                    apartmentName: data?.customerAddress || "N/A",
                    currentStage: data?.currentStage || "N/A",
                };

                if (value !== "Ops-1" && value !== "Ops-2 (Factory)") {
                    obj.materialDispatchedDate = data?.materialDispatchedDate
                        ? moment(data?.materialDispatchedDate).utc().format("DD-MM-YYYY")
                        : "-";
                }

                if (value !== "Ops-1" && value !== "Ops-2 (Factory)" && value !== "Ops-3 (Execution)") {
                    obj.executionCompletionDate = data?.executionCompletionDate
                        ? moment(data?.executionCompletionDate).utc().format("DD-MM-YYYY")
                        : "-";
                }

                if (ShowDesignSignOffRevokeDate) {
                    obj.uniqueLeadNumber = data?.uniqueLeadNumber || "N/A";
                    obj.designSignoffRevokeDate = data?.designSignoffRevokeDate
                        ? moment(data?.designSignoffRevokeDate).utc().format("DD-MM-YYYY")
                        : "-";
                }

                if (value === "Ops-1") {
                    obj.customerName = data?.customerName || "N/A";
                    obj.chmName = data?.chmUserName || "N/A";
                }

                if (value === "Summary of Completion") {
                    obj.executionMWPDate = data?.executionMWPDate
                        ? moment(data?.executionMWPDate).utc().format("DD-MM-YYYY")
                        : "-";
                }

                csvArray.push(obj);
            }
            setTableCsvData(csvArray);
            setTimeout(() => {
                tableCsvButtonRef.current.link.click();
            });
        } catch (error) {
            console.log("error", error);
            props?.setSnackInfo(
                error?.response?.data?.message ?? "Something went wrong",
                "error"
            );
        }
        setLoading(false);
    };

    // Function verify User
    // const verifyDataVisibilityAccess = () => {
    // 	if (
    // 		findMatchingUser(userDetails?._id) ||
    // 		userDetails?.roles.find(
    // 			(role) => role.name === ROLENAME.DGM_Ops || role.name === ROLENAME.DataAnalyst || role.name === ROLENAME.FinanceManager
    // 		)
    // 	) {
    // 		setValue("Summary of Delivery");
    // 	} else if (
    // 		userDetails?.roles.find(
    // 			(role) => role.name === ROLENAME.SeniorOperationManager || role.name === ROLENAME.Admin
    // 		)
    // 	) {
    // 		setValue("Ops-1");
    // 	} else if (
    // 		userDetails?.roles.find(
    // 			(role) => role.name === ROLENAME.FactoryManager
    // 		) &&
    // 		userDetails?._id.toString() !== ThirumaleshId
    // 	) {
    // 		setValue("Ops-2 (Factory)");
    // 	} else if (
    // 		userDetails?.roles.find(
    // 			(role) =>
    // 				role.name === ROLENAME.DGM_Ops ||
    // 				role.name === ROLENAME.Execution_Manager
    // 		) ||
    // 		userDetails?._id === SriKrishnaId
    // 	) {
    // 		setValue("Ops-3 (Execution)");
    // 	} else if (
    // 		userDetails?.roles.find(
    // 			(role) =>
    // 				role.name === ROLENAME.DGM_Ops || role.name === ROLENAME.ExecutionUser
    // 		) ||
    // 		userDetails?._id === PalisettiTejaId ||
    // 		userDetails?._id === PalaPrasanthKumarId
    // 	) {
    // 		setValue("Ops-3 (MWP)");
    // 	}
    // };

    const dateFilterHandler = () => {
        getMaterialDeliveryDataCityWise(startDate, endDate, selectedSearchType, searchInput);
        getProjectCompletionDataCityWise(startDate, endDate, selectedSearchType, searchInput);
        getFactoryManagerDataForOps1Tab(selectedSearchType, searchInput);
        getUnderExecutionDataCityWise(startDate, endDate, selectedSearchType, searchInput);
    };

    const clearDateFilter = () => {
        setStartDate("");
        setEndDate("");
        setSearchInput("")
        setSelectedSearchType("")
        getMaterialDeliveryDataCityWise("", "", "", "");
        getProjectCompletionDataCityWise("", "", "", "");
        getFactoryManagerDataForOps1Tab("", "");
        getUnderExecutionDataCityWise("", "", "", "");
    };

    useEffect(() => {
        // verifyDataVisibilityAccess();
        getMaterialDeliveryDataCityWise(startDate, endDate, selectedSearchType, searchInput);
        getProjectCompletionDataCityWise(startDate, endDate, selectedSearchType, searchInput);
        getFactoryManagerDataForOps1Tab(selectedSearchType, searchInput);
        getUnderExecutionDataCityWise(startDate, endDate, selectedSearchType, searchInput);
    }, []);

    const handlePercentageChangeDelivery = (e, index) => {
        const value = e.target.value;
        setMaterialDeliveryPercentages((prev) => {
            const newPercentages = [...prev];
            newPercentages[index] = value;
            return newPercentages;
        });
    };

    const calculateValueDelivery = (index) => {
        const percentage = materialDeliveryPercentages[index] || 0;
        const grandTotal = materialDeliveryData.reduce((acc, data) => {
            const value = data.monthlyData[index]?.grandTotal || 0;
            return acc + (value / 1.18);
        }, 0);
        const valueInLakhs = (grandTotal * (percentage / 100)) / 2 / 100000;
        return valueInLakhs.toLocaleString("en-IN", {
            maximumFractionDigits: 2,
            minimumFractionDigits: 2
        });
    };

    const handlePercentageChangeCompletion = (e, index) => {
        const value = e.target.value;
        setProjectCompletionPercentages((prev) => {
            const newPercentages = [...prev];
            newPercentages[index] = value;
            return newPercentages;
        });
    };

    const calculateValueCompletion = (index) => {
        const percentage = projectCompletionPercentages[index] || 0;
        const grandTotal = projectCompetionData.reduce((acc, data) => {
            const value = data.monthlyData[index]?.grandTotal || 0;
            return acc + (value / 1.18);
        }, 0);
        const valueInLakhs = (grandTotal * (percentage / 100)) / 2 / 100000;
        return valueInLakhs.toLocaleString("en-IN", {
            maximumFractionDigits: 2,
            minimumFractionDigits: 2
        });
    }

    const handlePercentageChangeOps = (e, index) => {
        const value = e.target.value;
        setFactoryDataForOps1Percentages((prev) => {
            const newPercentages = [...prev];
            newPercentages[index] = value;
            return newPercentages;
        });
    };

    const calculateValueOps = (index) => {
        const percentage = factoryDataForOps1Percentages[index] || 0;
        const grandTotal = factoryDataForOps1.reduce((acc, data) => {
            const value = data.stageData[index]?.grandTotal || 0;
            return acc + (value / 1.18);
        }, 0);
        const valueInLakhs = (grandTotal * (percentage / 100)) / 2 / 100000;
        return valueInLakhs.toLocaleString("en-IN", {
            maximumFractionDigits: 2,
            minimumFractionDigits: 2
        });
    }

    const handlePercentageChangeOps3 = (e, index) => {
        const value = e.target.value;
        setUnderExecutionPercentages((prev) => {
            const newPercentages = [...prev];
            newPercentages[index] = value;
            return newPercentages;
        });
    };

    const calculateValueOps3 = (index) => {
        const percentage = underExecutionPercentages[index] || 0;
        const grandTotal = underExecutionData.reduce((acc, data) => {
            const value = data.monthlyData[index]?.grandTotal || 0;
            return acc + (value / 1.18);
        }, 0);
        const valueInLakhs = (grandTotal * (percentage / 100)) / 2 / 100000;
        return valueInLakhs.toLocaleString("en-IN", {
            maximumFractionDigits: 2,
            minimumFractionDigits: 2
        });
    }

    return (
        <Fragment>
            <>
                {/* Date filter component */}
                <Paper style={{ padding: 10, marginLeft: 25 }}>
                    <Grid
                        container
                        style={{ display: "flex", alignItems: "center" }}
                    >
                        <Grid item md={3} xs={12}>
                            <TextField
                                id="date"
                                name="startDate"
                                label="From Date"
                                type="date"
                                value={startDate}
                                onChange={(e) => setStartDate(e.target.value)}
                                InputLabelProps={{
                                    shrink: true,
                                }}
                                fullWidth
                                className={classes.textField}
                            />
                        </Grid>
                        <Grid item md={1} xs={12}></Grid>
                        <Grid item md={3} xs={12}>
                            <TextField
                                id="date"
                                name="endDate"
                                label="End Date"
                                type="date"
                                value={endDate}
                                onChange={(e) => setEndDate(e.target.value)}
                                InputLabelProps={{
                                    shrink: true,
                                }}
                                fullWidth
                                className={classes.textField}
                            />
                        </Grid>
                        <Grid item md={3} xs={12}>
                            <Button
                                variant="contained"
                                color="primary"
                                disabled={!startDate || !endDate}
                                onClick={dateFilterHandler}
                                style={{ marginLeft: 10 }}
                                className={startDate && endDate ? classes.submitButton : ""}
                            >
                                Submit
                            </Button>
                        </Grid>
                        <Grid item md={2} xs={12}>
                            <Button
                                variant="contained"
                                color="secondary"
                                onClick={clearDateFilter}
                            >
                                Clear Filter
                            </Button>
                        </Grid>
                    </Grid>
                    <div style={{ display: 'flex', justifyContent: 'space-between', width: '100%', marginTop: '10px' }}>

                        {/* Search Type */}
                        <TextField
                            select
                            labelId="demo-simple-select-label"
                            id="demo-simple-select"
                            value={selectedSearchType}
                            label="Search Type"
                            name="searchType"
                            onChange={(e) => handleSearchType(e.target.value)}
                            variant="outlined"
                            style={{ width: '30%', marginRight: '2%' }}
                            size="small"
                        >
                            {searchTypes && searchTypes?.map((el, index) => (
                                <MenuItem key={index} value={el}>{el}</MenuItem>
                            ))}
                        </TextField>

                        {/* Search Input */}
                        <TextField
                            label="Enter the input"
                            name="searched"
                            size="small"
                            value={searchInput}
                            onChange={(e) => { setSearchInput(e.target.value) }}
                            variant="outlined"
                            style={{ width: '80%' }} />

                        {/* Search Button */}
                        <Button
                            disabled={!selectedSearchType || !searchInput}
                            variant="contained"
                            color="primary"
                            size="medium"
                            style={{ alignSelf: "center", marginLeft: 20 }} // Added height
                            className={classes.leadSearchButton}
                            onClick={() => handleSearch(searchInput.toUpperCase())}
                        >
                            Search
                        </Button>
                    </div>
                </Paper>

                {/* Summary of Delivery Values */}
                <div style={{ paddingTop: "20px", marginLeft: 25 }}>
                    <Paper
                        elevation={4}
                        style={{
                            padding: "20px",
                            borderRadius: "12px",
                            transition: "0.3s ease",
                        }}
                        onMouseEnter={(e) =>
                            (e.currentTarget.style.boxShadow = "0 6px 20px rgba(0,0,0,0.15)")
                        }
                        onMouseLeave={(e) => (e.currentTarget.style.boxShadow = "")}
                    >
                        <Card
                            style={{
                                borderRadius: "12px",
                                boxShadow: "0 4px 12px rgba(0,0,0,0.08)",
                                marginBottom: "10px",
                            }}
                        >
                            <CardContent style={{ padding: "16px 20px" }}>
                                <Grid container alignItems="center" justifyContent="space-between">
                                    <Grid
                                        item
                                        style={{
                                            display: "flex",
                                            alignItems: "center",
                                            gap: "10px",
                                        }}
                                    >
                                        <LocalShippingIcon style={{ color: "#355025" }} />

                                        <h2
                                            style={{
                                                margin: 0,
                                                fontWeight: 600,
                                                fontSize: "18px",
                                            }}
                                        >
                                            Summary Of Delivery
                                        </h2>
                                    </Grid>

                                    <Grid
                                        item
                                        style={{
                                            display: "flex",
                                            justifyContent: "flex-end",
                                            gap: "10px",
                                            alignItems: "center",
                                        }}
                                    >
                                        <Button
                                            onClick={handleRefreshClickSOD}
                                            variant="contained"
                                            startIcon={<RefreshIcon />}
                                            disabled={isDisabledSOD}
                                            style={{
                                                backgroundColor: isDisabledSOD ? "#cccccc" : "#F47E46",
                                                color: "#FFF2EB",
                                                height: "36px",
                                                textTransform: "none",
                                                borderRadius: "6px",
                                            }}
                                        >
                                            {isDisabledSOD
                                                ? `Wait (${formatTimeLeftSOD()})`
                                                : "Fetch New Data"}
                                        </Button>

                                        <CSVLink
                                            data={summaryOfDeliveryTableCsvData}
                                            filename={`Summary_Of_Delivery_Values_${moment().format(
                                                "YYYY-MM-DD"
                                            )}.csv`}
                                            ref={summaryOfDeliveryTableCsvButtonRef}
                                            style={{ display: "none" }}
                                        />

                                        <Button
                                            variant="contained"
                                            size="small"
                                            startIcon={<DownloadOutlined />}
                                            style={{
                                                backgroundColor: "#355025",
                                                color: "#FFF2EB",
                                                height: "36px",
                                                textTransform: "none",
                                                borderRadius: "6px",
                                            }}
                                            onClick={(e) => {
                                                e.preventDefault();
                                                e.stopPropagation();

                                                const csvData =
                                                    generateSummaryOfDeliveryTableCsvData();

                                                if (csvData.length > 0) {
                                                    setSummaryOfDeliveryTableCsvData(csvData);

                                                    setTimeout(() => {
                                                        if (
                                                            summaryOfDeliveryTableCsvButtonRef.current
                                                        ) {
                                                            summaryOfDeliveryTableCsvButtonRef.current.link.click();
                                                        }
                                                    }, 200);
                                                } else {
                                                    props?.setSnackInfo(
                                                        "No data available to export",
                                                        "warning"
                                                    );
                                                }
                                            }}
                                        >
                                            Download CSV
                                        </Button>
                                    </Grid>
                                </Grid>
                            </CardContent>
                        </Card>

                        <div className={classes.tablecontainer}>
                            <div className={classes.tableform}>
                                <div
                                    style={{
                                        width: "100%",
                                        boxSizing: "border-box",
                                    }}
                                >
                                    <TableContainer
                                        component={Paper}
                                        className={classes.table}
                                        style={{
                                            width: "100%",
                                            maxHeight: "700px",
                                            overflow: "auto",
                                            borderRadius: "12px"
                                        }}
                                        classes={{ root: classes.customTableContainer }}
                                    >
                                        <Table
                                            style={{ width: 450 }}
                                            className={classes.table}
                                            stickyHeader
                                            aria-label="sticky table"
                                        >
                                            <TableHead
                                                style={{
                                                    position: "sticky",
                                                    top: 0,
                                                    zIndex: 1,
                                                    background: "white",
                                                }}
                                            >
                                                <TableRow>
                                                    <TableCell
                                                        className={classes.cell}
                                                        style={{ position: "sticky", left: 0, zIndex: 9 }}
                                                    >
                                                        Modular Delivery Month
                                                    </TableCell>

                                                    {materialDeliveryData?.map((el, idx) => (
                                                        <TableCell
                                                            key={idx}
                                                            className={classes.cell}
                                                            style={{
                                                                zIndex: 2,
                                                                fontWeight:
                                                                    el?.locationDetail?.locationName ===
                                                                        "Grand Total"
                                                                        ? "700"
                                                                        : "",
                                                                textAlign: "center",
                                                            }}
                                                        >
                                                            {el?.locationDetail?.locationName !==
                                                                "Grand Total"
                                                                ? el?.locationDetail?.locationName
                                                                : "Grand Total (In Lakhs)"}
                                                        </TableCell>
                                                    ))}

                                                    <TableCell className={classes.cell}>Percentage</TableCell>
                                                    <TableCell className={classes.cell}>
                                                        Calculated Value
                                                    </TableCell>
                                                </TableRow>
                                            </TableHead>

                                            <TableBody style={{ position: 'sticky', top: 0 }}>
                                                {loadingSOD ? (
                                                    <TableRow>
                                                        <TableCell colSpan={100}>
                                                            <div
                                                                style={{
                                                                    display: "flex",
                                                                    justifyContent: "center",
                                                                    alignItems: "center",
                                                                    height: "300px",
                                                                    flexDirection: "column",
                                                                    gap: "10px",
                                                                }}
                                                            >
                                                                <CircularProgress />
                                                                <span>Loading data...</span>
                                                            </div>
                                                        </TableCell>
                                                    </TableRow>
                                                ) : (
                                                    materialDeliveryData[0]?.monthlyData?.map((el, i) => (
                                                        <TableRow key={i}>
                                                            <TableCell
                                                                className={classes.cell}
                                                                style={{
                                                                    position: "sticky",
                                                                    left: 0,
                                                                    zIndex: 9,
                                                                    fontWeight:
                                                                        el?.mmyyyy === "Grand Total"
                                                                            ? "700"
                                                                            : "",
                                                                }}
                                                            >
                                                                {el?.mmyyyy === "Grand Total"
                                                                    ? el?.mmyyyy
                                                                    : `${el?.mmyyyy.slice(0, 3)}-${el?.mmyyyy.slice(-2)}`}
                                                            </TableCell>

                                                            {materialDeliveryData.map((data, j) => (
                                                                <TableCell
                                                                    key={j}
                                                                    style={{
                                                                        zIndex: 1,
                                                                        background: "white",
                                                                        color: "black",
                                                                        textAlign: "center",
                                                                        fontWeight:
                                                                            el?.mmyyyy === "Grand Total" ||
                                                                                data?.locationDetail?.locationName ===
                                                                                "Grand Total"
                                                                                ? "700"
                                                                                : "",
                                                                    }}
                                                                    className={classes.tableCell}
                                                                    component="th"
                                                                    onClick={() =>
                                                                        showDetailedModalHandler(
                                                                            data?.monthlyData[i]?.data,
                                                                            "Summary of Delivery | " +
                                                                            data?.monthlyData[i]?.mmyyyy
                                                                        )
                                                                    }
                                                                >
                                                                    {formatToLakhs(
                                                                        data?.monthlyData[i]?.grandTotal / 1.18
                                                                    )}
                                                                </TableCell>
                                                            ))}

                                                            <TableCell
                                                                style={{
                                                                    zIndex: 1,
                                                                    background: "white",
                                                                    color: "black",
                                                                }}
                                                            >
                                                                <input
                                                                    type="number"
                                                                    value={
                                                                        materialDeliveryPercentages[i] || ""
                                                                    }
                                                                    onChange={(e) =>
                                                                        handlePercentageChangeDelivery(
                                                                            e,
                                                                            i
                                                                        )
                                                                    }
                                                                    placeholder="%"
                                                                    style={{
                                                                        width: "100%",
                                                                        padding: "10px",
                                                                        border: "2px solid #007BFF",
                                                                        borderRadius: "4px",
                                                                        fontSize: "16px",
                                                                        backgroundColor: "#F0F8FF",
                                                                    }}
                                                                />
                                                            </TableCell>

                                                            <TableCell
                                                                style={{
                                                                    zIndex: 1,
                                                                    background: "white",
                                                                    color: "black",
                                                                }}
                                                            >
                                                                {calculateValueDelivery(i)}
                                                            </TableCell>
                                                        </TableRow>
                                                    ))
                                                )}
                                            </TableBody>
                                        </Table>
                                    </TableContainer>
                                </div>
                            </div>
                        </div>
                    </Paper>
                </div>

                {/* Summary of Completion Values */}
                <div style={{ paddingTop: "20px", marginLeft: 25 }}>
                    <Paper
                        elevation={4}
                        style={{
                            padding: "20px",
                            borderRadius: "12px",
                            transition: "0.3s ease",
                        }}
                        onMouseEnter={(e) =>
                            (e.currentTarget.style.boxShadow = "0 6px 20px rgba(0,0,0,0.15)")
                        }
                        onMouseLeave={(e) => (e.currentTarget.style.boxShadow = "")}
                    >
                        <Card
                            style={{
                                borderRadius: "12px",
                                boxShadow: "0 4px 12px rgba(0,0,0,0.08)",
                                marginBottom: "10px",
                            }}
                        >
                            <CardContent style={{ padding: "16px 20px" }}>
                                <Grid container alignItems="center" justifyContent="space-between">
                                    <Grid
                                        item
                                        style={{
                                            display: "flex",
                                            alignItems: "center",
                                            gap: "10px",
                                        }}
                                    >
                                        <AssignmentTurnedInIcon style={{ color: "#355025" }} />

                                        <h2
                                            style={{
                                                margin: 0,
                                                fontWeight: 600,
                                                fontSize: "18px",
                                            }}
                                        >
                                            Summary Of Completion
                                        </h2>
                                    </Grid>

                                    <Grid
                                        item
                                        style={{
                                            display: "flex",
                                            justifyContent: "flex-end",
                                            gap: "10px",
                                            alignItems: "center",
                                        }}
                                    >
                                        <Button
                                            onClick={handleRefreshClickSOC}
                                            variant="contained"
                                            startIcon={<RefreshIcon />}
                                            disabled={isDisabledSOC}
                                            style={{
                                                backgroundColor: isDisabledSOC ? "#cccccc" : "#F47E46",
                                                color: "#FFF2EB",
                                                height: "36px",
                                                textTransform: "none",
                                                borderRadius: "6px",
                                            }}
                                        >
                                            {isDisabledSOC
                                                ? `Wait (${formatTimeLeftSOC()})`
                                                : "Fetch New Data"}
                                        </Button>

                                        <CSVLink
                                            data={summaryOfCompletionTableCsvData}
                                            filename={`Summary_Of_Completion_Values_${moment().format('YYYY-MM-DD')}.csv`}
                                            ref={summaryOfCompletionTableCsvButtonRef}
                                            style={{ textDecoration: 'none', display: 'none' }}
                                        />
                                        <Button
                                            variant='contained'
                                            size="small"
                                            startIcon={<DownloadOutlined />}
                                            onClick={(e) => {
                                                e.preventDefault();
                                                e.stopPropagation();

                                                const csvData = generateSummaryOfCompletionTableCsvData();

                                                if (csvData.length > 0) {
                                                    setSummaryOfCompletionTableCsvData(csvData);
                                                    setTimeout(() => {
                                                        setTriggerCompletionDownload(true);
                                                    }, 100);
                                                } else {
                                                    props?.setSnackInfo("No data available to export", "warning");
                                                }
                                            }}
                                            style={{
                                                backgroundColor: "#355025",
                                                color: "#FFF2EB",
                                                height: "36px",
                                                textTransform: "none",
                                                borderRadius: "6px",
                                            }}
                                        >
                                            Download CSV
                                        </Button>
                                    </Grid>
                                </Grid>
                            </CardContent>
                        </Card>
                        <div className={classes.tablecontainer}>
                            <div className={classes.tableform}>
                                <div
                                    style={{
                                        width: "100%",
                                        boxSizing: "border-box",
                                    }}
                                >
                                    <TableContainer
                                        component={Paper}
                                        className={classes.table}
                                        style={{
                                            width: "100%",
                                            maxHeight: "700px",
                                            overflow: "auto",
                                            borderRadius: "12px"
                                        }}
                                        classes={{ root: classes.customTableContainer }}
                                    >
                                        <Table
                                            className={classes.table}
                                            stickyHeader
                                            aria-label="sticky table"
                                        >
                                            <TableHead style={{ position: 'sticky', top: 0, zIndex: 9, background: 'white' }}>
                                                <TableRow>
                                                    <TableCell className={classes.cell} style={{ position: 'sticky', left: 0, zIndex: 9 }}>
                                                        Project Completion Month
                                                    </TableCell>
                                                    {projectCompetionData?.map((el, index) => {
                                                        return (
                                                            <TableCell
                                                                key={el?.locationDetail?.locationName || index}
                                                                className={classes.cell}
                                                                style={{
                                                                    zIndex: 2,
                                                                    fontWeight:
                                                                        el?.locationDetail?.locationName === "Grand Total"
                                                                            ? "700"
                                                                            : "",
                                                                    textAlign: "center",
                                                                }}
                                                            >
                                                                {el?.locationDetail?.locationName !== "Grand Total"
                                                                    ? el?.locationDetail?.locationName
                                                                    : "Grand Total (In Lakhs)"}
                                                            </TableCell>
                                                        );
                                                    })}
                                                    <TableCell className={classes.cell}>Percentage</TableCell>
                                                    <TableCell className={classes.cell}>Calculated Value</TableCell>
                                                </TableRow>
                                            </TableHead>
                                            <TableBody style={{ position: 'sticky', top: 0 }}>
                                                {loadingSOC ? (
                                                    <TableRow>
                                                        <TableCell colSpan={100}>
                                                            <div
                                                                style={{
                                                                    display: "flex",
                                                                    justifyContent: "center",
                                                                    alignItems: "center",
                                                                    height: "300px",
                                                                    flexDirection: "column",
                                                                    gap: "10px",
                                                                }}
                                                            >
                                                                <CircularProgress />
                                                                <span>Loading data...</span>
                                                            </div>
                                                        </TableCell>
                                                    </TableRow>
                                                ) : (
                                                    projectCompetionData[0]?.monthlyData?.map((el, i) => {
                                                        return (
                                                            <TableRow key={i}>
                                                                <TableCell
                                                                    className={classes.cell}
                                                                    style={{
                                                                        position: "sticky",
                                                                        left: 0,
                                                                        zIndex: 9,
                                                                        fontWeight:
                                                                            el?.mmyyyy === "Grand Total"
                                                                                ? "700"
                                                                                : "",
                                                                    }}
                                                                    component="th"
                                                                >
                                                                    {el?.mmyyyy === "Grand Total"
                                                                        ? el?.mmyyyy
                                                                        : `${el?.mmyyyy.slice(0, 3)}-${el?.mmyyyy.slice(-2)}`}
                                                                </TableCell>

                                                                {projectCompetionData.map((data, j) => {
                                                                    return (
                                                                        <TableCell
                                                                            key={j}
                                                                            style={{
                                                                                zIndex: 1,
                                                                                background: "white",
                                                                                color: "black",
                                                                                textAlign: "center",
                                                                                fontWeight:
                                                                                    el?.mmyyyy === "Grand Total" ||
                                                                                        data?.locationDetail?.locationName ===
                                                                                        "Grand Total"
                                                                                        ? "700"
                                                                                        : "",
                                                                            }}
                                                                            className={classes.tableCell}
                                                                            component="th"
                                                                            onClick={() => {
                                                                                showDetailedModalHandler(
                                                                                    data?.monthlyData[i]?.data,
                                                                                    "Summary of Completion" +
                                                                                    " | " +
                                                                                    data?.monthlyData[i]?.mmyyyy
                                                                                );
                                                                            }}
                                                                        >
                                                                            {formatToLakhs(
                                                                                data?.monthlyData[i]?.grandTotal / 1.18
                                                                            )}
                                                                        </TableCell>
                                                                    );
                                                                })}

                                                                <TableCell
                                                                    style={{
                                                                        zIndex: 1,
                                                                        background: "white",
                                                                        color: "black",
                                                                    }}
                                                                >
                                                                    <input
                                                                        type="number"
                                                                        onChange={(e) =>
                                                                            handlePercentageChangeCompletion(e, i)
                                                                        }
                                                                        value={projectCompletionPercentages[i] || ""}
                                                                        placeholder="%"
                                                                        style={{
                                                                            width: "100%",
                                                                            padding: "10px",
                                                                            border: "2px solid #007BFF",
                                                                            borderRadius: "4px",
                                                                            fontSize: "16px",
                                                                            backgroundColor: "#F0F8FF",
                                                                        }}
                                                                    />
                                                                </TableCell>

                                                                <TableCell
                                                                    style={{
                                                                        zIndex: 1,
                                                                        background: "white",
                                                                        color: "black",
                                                                    }}
                                                                >
                                                                    {calculateValueCompletion(i)}
                                                                </TableCell>
                                                            </TableRow>
                                                        );
                                                    })
                                                )}
                                            </TableBody>
                                        </Table>
                                    </TableContainer>
                                </div>
                            </div>
                        </div>
                    </Paper>
                </div>

                {/* Ops-1 Values */}
                <div style={{ paddingTop: "20px", marginLeft: 25 }}>
                    <Paper
                        elevation={4}
                        style={{
                            padding: "20px",
                            borderRadius: "12px",
                            transition: "0.3s ease",
                        }}
                        onMouseEnter={(e) =>
                            (e.currentTarget.style.boxShadow = "0 6px 20px rgba(0,0,0,0.15)")
                        }
                        onMouseLeave={(e) => (e.currentTarget.style.boxShadow = "")}
                    >
                        <Card
                            style={{
                                borderRadius: "12px",
                                boxShadow: "0 4px 12px rgba(0,0,0,0.08)",
                                marginBottom: "10px",
                            }}
                        >
                            <CardContent style={{ padding: "16px 20px" }}>
                                <Grid container alignItems="center" justifyContent="space-between">
                                    <Grid
                                        item
                                        style={{
                                            display: "flex",
                                            alignItems: "center",
                                            gap: "10px",
                                        }}
                                    >
                                        <BuildCircleIcon style={{ color: "#355025" }} />

                                        <h2
                                            style={{
                                                margin: 0,
                                                fontWeight: 600,
                                                fontSize: "18px",
                                            }}
                                        >
                                            Pre Production Summary
                                        </h2>
                                    </Grid>

                                    <Grid
                                        item
                                        style={{
                                            display: "flex",
                                            justifyContent: "flex-end",
                                            gap: "10px",
                                            alignItems: "center",
                                        }}
                                    >
                                        <Button
                                            onClick={handleRefreshClickPPS}
                                            variant="contained"
                                            startIcon={<RefreshIcon />}
                                            disabled={isDisabledPPS}
                                            style={{
                                                backgroundColor: isDisabledPPS ? "#cccccc" : "#F47E46",
                                                color: "#FFF2EB",
                                                height: "36px",
                                                textTransform: "none",
                                                borderRadius: "6px",
                                            }}
                                        >
                                            {isDisabledPPS
                                                ? `Wait (${formatTimeLeftPPS()})`
                                                : "Fetch New Data"}
                                        </Button>

                                        <CSVLink
                                            data={preProductionTableCsvData}
                                            filename={`Pre_Production_Summary_Values_${moment().format('YYYY-MM-DD')}.csv`}
                                            ref={preProductionTableCsvButtonRef}
                                            style={{ textDecoration: 'none', display: 'none' }}
                                        />
                                        <Button
                                            variant='contained'
                                            size="small"
                                            startIcon={<DownloadOutlined />}
                                            onClick={(e) => {
                                                e.preventDefault();
                                                e.stopPropagation();

                                                const csvData = generatePreProductionTableCsvData();

                                                if (csvData.length > 0) {
                                                    setPreProductionTableCsvData(csvData);
                                                    setTimeout(() => {
                                                        setTriggerPreProductionDownload(true);
                                                    }, 100);
                                                } else {
                                                    props?.setSnackInfo("No data available to export", "warning");
                                                }
                                            }}
                                            style={{
                                                backgroundColor: "#355025",
                                                color: "#FFF2EB",
                                                height: "36px",
                                                textTransform: "none",
                                                borderRadius: "6px",
                                            }}
                                        >
                                            Download CSV
                                        </Button>
                                    </Grid>
                                </Grid>
                            </CardContent>
                        </Card>
                        <div className={classes.tablecontainer}>
                            <div className={classes.tableform}>
                                <div
                                    style={{
                                        width: "100%",
                                        boxSizing: "border-box",
                                    }}
                                >
                                    <TableContainer component={Paper}
                                        className={classes.table}
                                        style={{
                                            width: "100%",
                                            maxHeight: "700px",
                                            overflow: "auto",
                                            borderRadius: "12px"
                                        }}
                                        classes={{ root: classes.customTableContainer }}>

                                        <Table style={{ width: 450 }}
                                            className={classes.table}
                                            stickyHeader
                                            aria-label="sticky table">
                                            <TableHead style={{ position: 'sticky', top: 0, zIndex: 9, background: 'white' }}>
                                                <TableRow>
                                                    <TableCell className={classes.cell} style={{ position: 'sticky', left: 0, zIndex: 9 }}>
                                                        Ops-1 Stages
                                                    </TableCell>
                                                    {factoryDataForOps1?.map((el, index) => {
                                                        return (
                                                            <TableCell
                                                                key={el?.locationDetail?.locationName || index}
                                                                className={classes.cell}
                                                                style={{
                                                                    zIndex: 2,
                                                                    fontWeight:
                                                                        el?.locationDetail?.locationName === "Grand Total"
                                                                            ? "700"
                                                                            : "",
                                                                }}
                                                            >
                                                                {el?.locationDetail?.locationName !== "Grand Total"
                                                                    ? el?.locationDetail?.locationName
                                                                    : "Grand Total (In Lakhs)"}
                                                            </TableCell>
                                                        );
                                                    })}
                                                    <TableCell className={classes.cell}>Percentage</TableCell>
                                                    <TableCell className={classes.cell}>Calculated Value</TableCell>
                                                </TableRow>
                                            </TableHead>

                                            <TableBody style={{ position: 'sticky', top: 0 }}>
                                                {loadingPPS ? (
                                                    <TableRow>
                                                        <TableCell colSpan={100}>
                                                            <div
                                                                style={{
                                                                    display: "flex",
                                                                    justifyContent: "center",
                                                                    alignItems: "center",
                                                                    height: "300px",
                                                                    flexDirection: "column",
                                                                    gap: "10px",
                                                                }}
                                                            >
                                                                <CircularProgress />
                                                                <span>Loading data...</span>
                                                            </div>
                                                        </TableCell>
                                                    </TableRow>
                                                ) : (
                                                    factoryDataForOps1[0]?.stageData?.map((el, i) => {
                                                        return (
                                                            <TableRow key={i}>
                                                                <TableCell
                                                                    className={classes.cell}
                                                                    style={{
                                                                        position: "sticky",
                                                                        left: 0,
                                                                        zIndex: 9,
                                                                        fontWeight:
                                                                            el?.stage === "Grand Total"
                                                                                ? "700"
                                                                                : "",
                                                                    }}
                                                                    component="th"
                                                                >
                                                                    {el?.stage}
                                                                </TableCell>

                                                                {factoryDataForOps1.map((data, j) => {
                                                                    return (
                                                                        <TableCell
                                                                            key={j}
                                                                            style={{
                                                                                zIndex: 1,
                                                                                background: "white",
                                                                                color: "black",
                                                                                textAlign: "center",
                                                                                fontWeight:
                                                                                    el?.stage === "Grand Total" ||
                                                                                        data?.locationDetail
                                                                                            ?.locationName ===
                                                                                        "Grand Total"
                                                                                        ? "700"
                                                                                        : "",
                                                                            }}
                                                                            component="th"
                                                                            className={classes.tableCell}
                                                                            onClick={() => {
                                                                                showDetailedModalHandler(
                                                                                    data?.stageData[i]?.data,
                                                                                    "Ops-1" +
                                                                                    " | " +
                                                                                    data?.stageData[i]?.stage
                                                                                );
                                                                            }}
                                                                        >
                                                                            {formatToLakhs(
                                                                                data?.stageData[i]?.grandTotal /
                                                                                1.18 || 0
                                                                            )}
                                                                        </TableCell>
                                                                    );
                                                                })}

                                                                <TableCell
                                                                    style={{
                                                                        zIndex: 1,
                                                                        background: "white",
                                                                        color: "black",
                                                                    }}
                                                                >
                                                                    <input
                                                                        type="number"
                                                                        onChange={(e) =>
                                                                            handlePercentageChangeOps(e, i)
                                                                        }
                                                                        value={
                                                                            factoryDataForOps1Percentages[i] ||
                                                                            ""
                                                                        }
                                                                        placeholder="%"
                                                                        style={{
                                                                            width: "100%",
                                                                            padding: "10px",
                                                                            border: "2px solid #007BFF",
                                                                            borderRadius: "4px",
                                                                            fontSize: "16px",
                                                                            backgroundColor: "#F0F8FF",
                                                                        }}
                                                                    />
                                                                </TableCell>

                                                                <TableCell
                                                                    style={{
                                                                        zIndex: 1,
                                                                        background: "white",
                                                                        color: "black",
                                                                    }}
                                                                >
                                                                    {calculateValueOps(i)}
                                                                </TableCell>
                                                            </TableRow>
                                                        );
                                                    })
                                                )}
                                            </TableBody>
                                        </Table>
                                    </TableContainer>
                                </div>
                            </div>
                        </div>
                    </Paper>
                </div>

                {/* Ops-3 Under Execution Values */}
                <div style={{ paddingTop: "20px", marginLeft: 25 }}>
                    <Paper
                        elevation={4}
                        style={{
                            padding: "20px",
                            borderRadius: "12px",
                            transition: "0.3s ease",
                        }}
                        onMouseEnter={(e) =>
                            (e.currentTarget.style.boxShadow = "0 6px 20px rgba(0,0,0,0.15)")
                        }
                        onMouseLeave={(e) => (e.currentTarget.style.boxShadow = "")}
                    >
                        <Card
                            style={{
                                borderRadius: "12px",
                                boxShadow: "0 4px 12px rgba(0,0,0,0.08)",
                                marginBottom: "10px",
                            }}
                        >
                            <CardContent style={{ padding: "16px 20px" }}>
                                <Grid container alignItems="center" justifyContent="space-between">
                                    <Grid
                                        item
                                        style={{
                                            display: "flex",
                                            alignItems: "center",
                                            gap: "10px",
                                        }}
                                    >
                                        <AutorenewIcon style={{ color: "#355025" }} />

                                        <h2
                                            style={{
                                                margin: 0,
                                                fontWeight: 600,
                                                fontSize: "18px",
                                            }}
                                        >
                                            Under Execution Summary
                                        </h2>
                                    </Grid>

                                    <Grid
                                        item
                                        style={{
                                            display: "flex",
                                            justifyContent: "flex-end",
                                            gap: "10px",
                                            alignItems: "center",
                                        }}
                                    >
                                        <Button
                                            onClick={handleRefreshClickUES}
                                            variant="contained"
                                            startIcon={<RefreshIcon />}
                                            disabled={isDisabledUES}
                                            style={{
                                                backgroundColor: isDisabledUES ? "#cccccc" : "#F47E46",
                                                color: "#FFF2EB",
                                                height: "36px",
                                                textTransform: "none",
                                                borderRadius: "6px",
                                            }}
                                        >
                                            {isDisabledUES
                                                ? `Wait (${formatTimeLeftUES()})`
                                                : "Fetch New Data"}
                                        </Button>

                                        <CSVLink
                                            data={underExecutionTableCsvData}
                                            filename={`Under_Execution_Summary_Values_${moment().format('YYYY-MM-DD')}.csv`}
                                            ref={underExecutionTableCsvButtonRef}
                                            style={{ textDecoration: 'none', display: 'none' }}
                                        />
                                        <Button
                                            variant='contained'
                                            size="small"
                                            startIcon={<DownloadOutlined />}
                                            onClick={(e) => {
                                                e.preventDefault();
                                                e.stopPropagation();

                                                const csvData = generateUnderExecutionTableCsvData();

                                                if (csvData.length > 0) {
                                                    setUnderExecutionTableCsvData(csvData);
                                                    setTimeout(() => {
                                                        setTriggerUnderExecutionDownload(true);
                                                    }, 100);
                                                } else {
                                                    props?.setSnackInfo("No data available to export", "warning");
                                                }
                                            }}
                                            style={{
                                                backgroundColor: "#355025",
                                                color: "#FFF2EB",
                                                height: "36px",
                                                textTransform: "none",
                                                borderRadius: "6px",
                                            }}
                                        >
                                            Download CSV
                                        </Button>
                                    </Grid>
                                </Grid>
                            </CardContent>
                        </Card>
                        <div className={classes.tablecontainer}>
                            <div className={classes.tableform}>
                                <div
                                    style={{
                                        width: "100%",
                                        boxSizing: "border-box",
                                    }}
                                >
                                    <TableContainer component={Paper}
                                        className={classes.table}
                                        style={{
                                            width: "100%",
                                            maxHeight: "700px",
                                            overflow: "auto",
                                            borderRadius: "12px"
                                        }}
                                        classes={{ root: classes.customTableContainer }}>

                                        <Table style={{ width: 450 }}
                                            className={classes.table}
                                            stickyHeader
                                            aria-label="sticky table">
                                            <TableHead style={{ position: 'sticky', top: 0, zIndex: 9, background: 'white' }}>
                                                <TableRow>
                                                    <TableCell className={classes.cell} style={{ position: 'sticky', left: 0, zIndex: 9 }}>
                                                        Modular Delivery Month
                                                    </TableCell>
                                                    {underExecutionData?.map((el, index) => {
                                                        return (
                                                            <TableCell
                                                                key={el?.locationDetail?.locationName || index}
                                                                className={classes.cell}
                                                                component="th"
                                                                style={{
                                                                    zIndex: 2,
                                                                    fontWeight:
                                                                        el?.locationDetail?.locationName === "Grand Total"
                                                                            ? "700"
                                                                            : "",
                                                                }}
                                                            >
                                                                {el?.locationDetail?.locationName !== "Grand Total"
                                                                    ? el?.locationDetail?.locationName
                                                                    : "Grand Total (In Lakhs)"}
                                                            </TableCell>
                                                        );
                                                    })}
                                                    <TableCell className={classes.cell}>Percentage</TableCell>
                                                    <TableCell className={classes.cell}>Calculated Value</TableCell>
                                                </TableRow>
                                            </TableHead>
                                            <TableBody style={{ position: 'sticky', top: 0 }}>
                                                {loadingUES ? (
                                                    <TableRow>
                                                        <TableCell colSpan={100}>
                                                            <div
                                                                style={{
                                                                    display: "flex",
                                                                    justifyContent: "center",
                                                                    alignItems: "center",
                                                                    height: "300px",
                                                                    flexDirection: "column",
                                                                    gap: "10px",
                                                                }}
                                                            >
                                                                <CircularProgress />
                                                                <span>Loading data...</span>
                                                            </div>
                                                        </TableCell>
                                                    </TableRow>
                                                ) : (
                                                    underExecutionData[0]?.monthlyData?.map((el, i) => {
                                                        return (
                                                            <TableRow key={i}>
                                                                <TableCell
                                                                    className={classes.cell}
                                                                    style={{
                                                                        position: "sticky",
                                                                        left: 0,
                                                                        zIndex: 9,
                                                                        fontWeight:
                                                                            el?.mmyyyy === "Grand Total"
                                                                                ? "700"
                                                                                : "",
                                                                    }}
                                                                    component="th"
                                                                >
                                                                    {el?.mmyyyy === "Grand Total"
                                                                        ? el?.mmyyyy
                                                                        : `${el?.mmyyyy.slice(0, 3)}-${el?.mmyyyy.slice(-2)}`}
                                                                </TableCell>

                                                                {underExecutionData?.map((data, j) => {
                                                                    return (
                                                                        <TableCell
                                                                            key={j}
                                                                            component="th"
                                                                            style={{
                                                                                zIndex: 1,
                                                                                background: "white",
                                                                                color: "black",
                                                                                textAlign: "center",
                                                                                fontWeight:
                                                                                    el?.mmyyyy === "Grand Total" ||
                                                                                        data?.locationDetail
                                                                                            ?.locationName ===
                                                                                        "Grand Total"
                                                                                        ? "700"
                                                                                        : "",
                                                                            }}
                                                                            className={classes.tableCell}
                                                                            onClick={() => {
                                                                                showDetailedModalHandler(
                                                                                    data?.monthlyData[i]?.data,
                                                                                    "Ops-3 Under Execution" +
                                                                                    " | " +
                                                                                    data?.monthlyData[i]?.mmyyyy
                                                                                );
                                                                            }}
                                                                        >
                                                                            {formatToLakhs(
                                                                                data?.monthlyData[i]?.grandTotal / 1.18
                                                                            )}
                                                                        </TableCell>
                                                                    );
                                                                })}

                                                                <TableCell
                                                                    style={{
                                                                        zIndex: 1,
                                                                        background: "white",
                                                                        color: "black",
                                                                    }}
                                                                >
                                                                    <input
                                                                        type="number"
                                                                        onChange={(e) =>
                                                                            handlePercentageChangeOps3(e, i)
                                                                        }
                                                                        value={underExecutionPercentages[i] || ""}
                                                                        placeholder="%"
                                                                        style={{
                                                                            width: "100%",
                                                                            padding: "10px",
                                                                            border: "2px solid #007BFF",
                                                                            borderRadius: "4px",
                                                                            fontSize: "16px",
                                                                            backgroundColor: "#F0F8FF",
                                                                        }}
                                                                    />
                                                                </TableCell>

                                                                <TableCell
                                                                    style={{
                                                                        zIndex: 1,
                                                                        background: "white",
                                                                        color: "black",
                                                                    }}
                                                                >
                                                                    {calculateValueOps3(i)}
                                                                </TableCell>
                                                            </TableRow>
                                                        );
                                                    })
                                                )}
                                            </TableBody>
                                        </Table>
                                    </TableContainer>
                                </div>
                            </div>
                        </div>
                    </Paper>
                </div>
            </>
            <Modal
                title={title}
                centered
                visible={showDetailedModal}
                onCancel={() => setShowDetailedModal(false)}
                width={1000}
                maskClosable={true}
                footer={null}
            >
                <div className={classes.csv}>
                    <CSVLink
                        headers={headers}
                        filename={title.replace("|", "-") + ".csv"}
                        data={csvData}
                        ref={csvButtonRef}
                    />
                    <Button
                        onClick={() => csvDownloadHandler(null)}
                        style={{ backgroundColor: "#355025", color: "#FFF2EB", marginRight: '10px' }}
                        variant="contained"
                        color="secondary"
                    >
                        Download CSV
                    </Button>
                </div>

                {detailDataArray && (
                    <TableContainer component={Paper} className={classes.table}>
                        <Table
                            style={{ width: 450 }}
                            className={classes.table}
                            stickyHeader
                            aria-label="sticky table"
                        >
                            <TableHead>
                                <StyledTableRow>
                                    <StyledTableCell>Sl. No.</StyledTableCell>
                                    <StyledTableCell>Project No.</StyledTableCell>
                                    <StyledTableCell>Lead No.</StyledTableCell>
                                    <StyledTableCell>Stage</StyledTableCell>
                                    <StyledTableCell>Department</StyledTableCell>
                                    <StyledTableCell>Value (INR)</StyledTableCell>
                                    <StyledTableCell>City</StyledTableCell>
                                    <StyledTableCell>Sales Won Date</StyledTableCell>
                                    <StyledTableCell>Design Sign-Off Date</StyledTableCell>
                                    <StyledTableCell>Material Delivery Date</StyledTableCell>
                                    <StyledTableCell>Actual Completion Date</StyledTableCell>
                                    <StyledTableCell>Designer/ADM name</StyledTableCell>
                                    <StyledTableCell>Apartment Name</StyledTableCell>
                                    <StyledTableCell>Current stage</StyledTableCell>
                                    <StyledTableCell>Customer name</StyledTableCell>
                                    <StyledTableCell>MWP Completion Date</StyledTableCell>
                                    {/* <StyledTableCell>CHM Name</StyledTableCell> */}
                                </StyledTableRow>
                            </TableHead>
                            <TableBody>
                                {detailDataArray?.map((data, i) => {
                                    return (
                                        <StyledTableRow key={i}>
                                            <StyledTableCell component="th">{i + 1}</StyledTableCell>
                                            <StyledTableCell
                                                component="th"
                                                style={{ textAlign: "center" }}
                                            >
                                                {/* {data?.erpProjectNo || "N/A"} */}
                                                {
                                                    data.erpProjectNo ?
                                                        <Link to={`/project-logs/${data?._id}`} target="_blank" rel="noopener noreferrer" style={{ color: "#000", textDecoration: 'underline', textAlign: 'center' }}>  {data.erpProjectNo}</Link> :
                                                        'NA'
                                                }
                                            </StyledTableCell>
                                            <StyledTableCell
                                                component="th"
                                                style={{ textAlign: "center" }}
                                            >
                                                {/* {data?.lead_no} */}
                                                {
                                                    data.lead_no ?
                                                        <Link to={`/project-logs/${data._id}`} target="_blank" rel="noopener noreferrer" style={{ color: "#000", textDecoration: 'underline', textAlign: 'center' }}>  {data.lead_no}</Link> :
                                                        'NA'
                                                }
                                            </StyledTableCell>
                                            <StyledTableCell
                                                component="th"
                                                style={{ textAlign: "center" }}
                                            >
                                                {data?.currentStage}
                                            </StyledTableCell>
                                            <StyledTableCell
                                                component="th"
                                                style={{ textAlign: "center" }}
                                            >
                                                {data?.departmentName}
                                            </StyledTableCell>
                                            {/* <StyledTableCell
                                                component="th"
                                                style={{ textAlign: "center" }}
                                            >
                                                {data?.customerId?.name || "N/A"}
                                            </StyledTableCell> */}
                                            <StyledTableCell
                                                component="th"
                                                style={{ textAlign: "center" }}
                                            >
                                                {(data?.grandTotal / 1.18)?.toLocaleString("en-IN", {
                                                    maximumFractionDigits: 2, // Maximum number of decimal places
                                                    style: "currency",
                                                    currency: "INR",
                                                })}
                                            </StyledTableCell>
                                            <StyledTableCell
                                                component="th"
                                                style={{ textAlign: "center" }}
                                            >
                                                {data?.cityName || "N/A"}
                                            </StyledTableCell>
                                            <StyledTableCell
                                                component="th"
                                                style={{ textAlign: "center" }}
                                            >
                                                {data?.leadWonDate
                                                    ? moment(data?.leadWonDate).utc().format("DD-MM-YYYY")
                                                    : "-"}
                                            </StyledTableCell>
                                            <StyledTableCell
                                                component="th"
                                                style={{ textAlign: "center" }}
                                            >
                                                {data?.customerDesignSignOffDate
                                                    ? moment(data?.customerDesignSignOffDate)
                                                        .utc()
                                                        .format("DD-MM-YYYY")
                                                    : "-"}
                                            </StyledTableCell>
                                            <StyledTableCell
                                                component="th"
                                                style={{ textAlign: "center" }}
                                            >
                                                {data?.materialDispatchedDate
                                                    ? moment(data?.materialDispatchedDate)
                                                        .utc()
                                                        .format("DD-MM-YYYY")
                                                    : "-"}
                                            </StyledTableCell>
                                            <StyledTableCell
                                                component="th"
                                                style={{ textAlign: "center" }}
                                            >
                                                {data?.executionCompletionDate
                                                    ? moment(data?.executionCompletionDate)
                                                        .utc()
                                                        .format("DD-MM-YYYY")
                                                    : "-"}
                                            </StyledTableCell>
                                            <StyledTableCell
                                                component="th"
                                                style={{ textAlign: "center" }}
                                            >
                                                {data?.designUserName || "N/A"}
                                                {" / "}
                                                {data?.designManagerName || "N/A"}
                                            </StyledTableCell> <StyledTableCell
                                                component="th"
                                                style={{ textAlign: "center" }}
                                            >
                                                {data?.customerAddress || "N/A"}
                                            </StyledTableCell>
                                            <StyledTableCell
                                                component="th"
                                                style={{ textAlign: "center" }}
                                            >
                                                {data?.currentStage || "N/A"}
                                            </StyledTableCell><StyledTableCell
                                                component="th"
                                                style={{ textAlign: "center" }}
                                            >
                                                {data?.customerName || "N/A"}
                                            </StyledTableCell>
                                            <StyledTableCell
                                                component="th"
                                                style={{ textAlign: "center" }}
                                            >
                                                {data?.executionMWPDate
                                                    ? moment(data?.executionMWPDate)
                                                        .utc()
                                                        .format("DD-MM-YYYY")
                                                    : "-"}
                                            </StyledTableCell>
                                        </StyledTableRow>
                                    );
                                })}
                            </TableBody>
                        </Table>
                    </TableContainer>
                )}
            </Modal>
        </Fragment>
    );
};

export default connect(null, { setLoading })(StageValue);